function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Vue-datepicker v0.2.11
 * (c) 2019-2020 Mathieu Stanowski
 */
import { clearAllBodyScrollLocks as t, disableBodyScroll as e, enableBodyScroll as n } from "body-scroll-lock";
import r from "vue";
import i from "dayjs";

var a = function a(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
},
    o = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
  weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
  weekStart: 0,
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  ordinal: function ordinal(t) {
    var e = ["th", "st", "nd", "rd"],
        n = t % 100;
    return "[".concat(t).concat(e[(n - 20) % 10] || e[n] || e[0], "]");
  },
  buttonValidate: "Ok",
  buttonCancel: "Cancel",
  rangeHeaderText: "From %d To %d"
},
    s = {
  name: "fr",
  weekdays: "Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi".split("_"),
  months: "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre".split("_"),
  weekStart: 1,
  weekdaysShort: "Dim_Lun_Mar_Mer_Jeu_Ven_Sam".split("_"),
  monthsShort: "Janv_Févr_Mars_Avr_Mai_Juin_Juil_Août_Sept_Oct_Nov_Déc".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  ordinal: function ordinal(t) {
    return t;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  },
  buttonValidate: "Ok",
  buttonCancel: "Annuler",
  rangeHeaderText: "Du %d Au %d"
},
    c = {
  name: "es",
  monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
  weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
  weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
  weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
  months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
  weekStart: 1,
  formats: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY H:mm",
    LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
  },
  ordinal: function ordinal(t) {
    return "".concat(t, "º");
  },
  buttonValidate: "Ok",
  buttonCancel: "Anular",
  rangeHeaderText: "Del %d Al %d"
},
    l = {
  name: "de",
  weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
  weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
  months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
  monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
  ordinal: function ordinal(t) {
    return "".concat(t, ".");
  },
  weekStart: 1,
  formats: {
    LTS: "HH:mm:ss",
    LT: "HH:mm",
    L: "DD.MM.YYYY",
    LL: "D. MMMM YYYY",
    LLL: "D. MMMM YYYY HH:mm",
    LLLL: "dddd, D. MMMM YYYY HH:mm"
  },
  buttonValidate: "Ok",
  buttonCancel: "Abbrechen",
  rangeHeaderText: "Vom %d Bis %d"
},
    u = {
  name: "he",
  weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
  weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
  weekdaysMin: "א׳_ב׳_ג׳_ד׳_ה׳_ו_ש׳".split("_"),
  months: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
  monthsShort: "ינו_פבר_מרץ_אפר_מאי_יונ_יול_אוג_ספט_אוק_נוב_דצמ".split("_"),
  ordinal: function ordinal(t) {
    return t;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D [ב]MMMM YYYY",
    LLL: "D [ב]MMMM YYYY HH:mm",
    LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
    l: "D/M/YYYY",
    ll: "D MMM YYYY",
    lll: "D MMM YYYY HH:mm",
    llll: "ddd, D MMM YYYY HH:mm"
  },
  buttonValidate: "אישור",
  buttonCancel: "ביטול",
  rangeHeaderText: "מתאריך %d עד תאריך %d"
},
    d = {
  name: "ru",
  weekdays: "Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота".split("_"),
  weekdaysShort: "Вс_Пн_Вт_Ср_Чт_Пт_Сб".split("_"),
  weekdaysMin: "Вс_Пн_Вт_Ср_Чт_Пт_Сб".split("_"),
  months: "Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь".split("_"),
  monthsShort: "Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек".split("_"),
  weekStart: 1,
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  ordinal: function ordinal(t) {
    return t;
  },
  buttonValidate: "Ок",
  buttonCancel: "Отмена",
  rangeHeaderText: "От %d До %d"
},
    h = {
  name: "sv",
  weekdays: "Söndag_Måndag_Tisdag_Onsdag_Torsdag_Fredag_Lördag".split("_"),
  weekdaysShort: "Sön_Mån_Tis_Ons_Tor_Fre_Lör".split("_"),
  weekdaysMin: "Sö_Må_Ti_On_To_Fr_Lö".split("_"),
  months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
  monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
  weekStart: 0,
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  ordinal: function ordinal(t) {
    var e = ["th", "st", "nd", "rd"],
        n = t % 100;
    return "[".concat(t).concat(e[(n - 20) % 10] || e[n] || e[0], "]");
  },
  buttonValidate: "Ok",
  buttonCancel: "Avbryt",
  rangeHeaderText: "Från %d till %d"
},
    p = Object.freeze({
  __proto__: null,
  fr: s,
  en: o,
  es: c,
  de: l,
  he: u,
  ru: d,
  sv: h
}),
    f = ["name", "weekdays", "weekdaysShort", "weekdaysMin", "weekStart", "months", "monthsShort", "ordinal", "formats", "buttonCancel", "buttonValidate", "rangeHeaderText"],
    m = {
  date: "DD MMMM YYYY",
  month: "MMMM YYYY",
  quarter: "YYYY-[Q]Q",
  year: "YYYY",
  range: "DD MMMM YYYY"
},
    v = {
  date: "YYYY-MM-DD",
  month: "YYYY-MM",
  quarter: "YYYY-Q",
  year: "YYYY",
  range: "YYYY-MM-DD"
},
    y = {
  date: "dddd DD MMMM",
  month: "MMMM",
  quarter: "[Q]Q",
  year: "YYYY",
  range: "DD MMMM YYYY"
},
    g = 1900,
    b = 3e3,
    D = "date",
    _ = "month",
    k = "quarter",
    O = "year",
    M = /(%d)+/,
    w = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34
});

function Y(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function S(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? Y(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Y(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var x = r.extend({
  name: "Localable",
  props: {
    locale: {
      type: Object,
      default: function _default() {
        return {
          lang: void 0
        };
      }
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      var t = this.locale.lang;
      return S(S({}, this.locale), {}, {
        lang: this.getLocale(t)
      });
    }
  },
  methods: {
    getDefaultLang: function getDefaultLang() {
      return (this.$vuedatepicker && this.$vuedatepicker.lang || window.navigator.userLanguage || window.navigator.language || "en").substr(0, 2);
    },
    isValidLocale: function isValidLocale() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = Object.keys(t);
      return e.length > 0 && e.every(function (t) {
        return f.includes(t);
      });
    },
    getLocale: function getLocale(t) {
      return this.isValidLocale(t) ? t : p[t] || this.getLocale(this.getDefaultLang());
    }
  }
}),
    C = r.extend({
  name: "Mobile",
  props: {
    mobileBreakpoint: {
      type: [Number, String],
      default: 576,
      validator: function validator(t) {
        return !isNaN(Number(t));
      }
    }
  },
  data: function data() {
    return {
      width: 0,
      mobile: !1,
      resizeTimeout: void 0
    };
  },
  computed: {
    isMobile: function isMobile() {
      return this.mobile;
    }
  },
  created: function created() {
    var t = this;
    window && (window.addEventListener("resize", this.onResize, {
      passive: !0
    }), this.$on("hook:destroyed", function () {
      window.removeEventListener("resize", t.onResize, {
        passive: !0
      });
    }), this.update());
  },
  methods: {
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(this.update, 200);
    },
    update: function update() {
      var t = this.getClientWidth();
      this.width = t, this.mobile = t < parseInt(this.mobileBreakpoint, 10);
    },
    getClientWidth: function getClientWidth() {
      return "undefined" == typeof document ? 0 : Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
  }
});
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;

function $(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

var L = $(function (t) {
  function e(n) {
    return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? t.exports = e = function e(t) {
      return _typeof(t);
    } : t.exports = e = function e(t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    }, e(n);
  }

  t.exports = e;
}),
    j = ["click"],
    P = [],
    T = {
  instances: P,
  bind: E,
  update: function update(t, e) {
    JSON.stringify(e.value) !== JSON.stringify(e.oldValue) && E(t, e);
  },
  unbind: A
};

function E(t, e) {
  var n = e.value;
  A(t);
  var r = n,
      i = "function" == typeof r,
      a = "object" === L(r);

  if ((i || a) && !(!1 === r.isActive)) {
    var o = function (t) {
      var e = t.el,
          n = t.handler;
      return {
        el: e,
        eventHandlers: j.map(function (t) {
          return {
            event: t,
            handler: function handler(t) {
              return function (t) {
                var e = t.event,
                    n = t.el,
                    r = t.handler,
                    i = e.path || (e.composedPath ? e.composedPath() : void 0);
                if (i ? i.indexOf(n) < 0 : !n.contains(e.target)) return r(e, n);
              }({
                event: t,
                el: e,
                handler: n
              });
            }
          };
        })
      };
    }({
      el: t,
      handler: i ? r : r.handler
    });

    o.eventHandlers.forEach(function (t) {
      var e = t.event,
          n = t.handler;
      return setTimeout(function () {
        return document.addEventListener(e, n, !1);
      }, 0);
    }), P.push(o);
  }
}

function A(t) {
  var e = P.findIndex(function (e) {
    return e.el === t;
  });
  -1 !== e && (P[e].eventHandlers.forEach(function (t) {
    var e = t.event,
        n = t.handler;
    return document.removeEventListener(e, n, !1);
  }), P.splice(e, 1));
}

var H = {
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: Boolean,
      required: !1
    }
  },
  data: function data() {
    return {
      isActive: !1
    };
  },
  watch: {
    value: {
      handler: function handler(t) {
        this.isActive = t;
      },
      immediate: !0
    },
    isActive: function isActive(t) {
      t !== this.value && this.$emit("input", t);
    }
  }
};

function N(t, e, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
      i = function i(a) {
    n(a), t.removeEventListener(e, i, r);
  };

  t.addEventListener(e, i, r);
}

function B(t) {
  var e = L(t);
  return "boolean" === e || "string" === e || t.nodeType === Node.ELEMENT_NODE;
}

function F(t) {
  if (null != t && "" !== t) return isNaN(+t) ? String(t) : "".concat(Number(t), "px");
}

function I(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
  return t.$scopedSlots[e] ? t.$scopedSlots[e] && t.$scopedSlots[e](n) : !t.$slots[e] || n && !r ? void 0 : t.$slots[e];
}

function V(t) {
  if (!t || t.nodeType !== Node.ELEMENT_NODE) return 0;
  var e = +window.getComputedStyle(t).getPropertyValue("z-index");
  return e || V(t.parentNode);
}

var z = {
  mixins: [H],
  props: {
    activator: {
      default: void 0,
      validator: function validator(t) {
        return ["string", "object"].includes(L(t));
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data: function data() {
    return {
      activatorElement: void 0,
      activatorNode: []
    };
  },
  watch: {
    activator: "resetActivator"
  },
  mounted: function mounted() {
    var t,
        e,
        n,
        r = (e = "activator", n = !0, (t = this).$slots[e] && t.$scopedSlots[e] && t.$scopedSlots[e].name ? n ? "v-slot" : "scoped" : t.$slots[e] ? "normal" : t.$scopedSlots[e] ? "scoped" : void 0);
    r && ["v-slot", "normal"].includes(r) && console.error('The activator slot must be bound, try \'<template v-slot:activator="{ on }"><button v-on="on">\'', this), this.getActivator();
  },
  methods: {
    resetActivator: function resetActivator() {
      this.activatorElement = void 0, this.getActivator();
    },
    genActivator: function genActivator() {
      var t = I(this, "activator", Object.assign(this.getValueProxy(), {
        attrs: {
          role: "button",
          "aria-haspopup": !0,
          "aria-expanded": String(this.isActive)
        }
      })) || [];
      return this.activatorNode = t, t;
    },
    getActivator: function getActivator(t) {
      if (this.activatorElement) return this.activatorElement;
      var e;

      if (this.activator) {
        var n = document;
        e = "string" == typeof this.activator ? n.querySelector(this.activator) : this.activator.$el ? this.activator.$el : this.activator;
      } else t ? e = t.currentTarget || t.target : this.activatorNode.length && (e = this.activatorNode[0].elm);

      return this.activatorElement = e, this.activatorElement;
    },
    getContentSlot: function getContentSlot() {
      return I(this, "default", this.getValueProxy(), !0);
    },
    getValueProxy: function getValueProxy() {
      var t = this;
      return {
        get value() {
          return t.isActive;
        },

        set value(e) {
          t.isActive = e;
        }

      };
    }
  }
};

var W = function W(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
};

var q = function q(t) {
  if (Array.isArray(t)) return W(t);
};

var R = function R(t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
};

var J = function J(t, e) {
  if (t) {
    if ("string" == typeof t) return W(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? W(t, e) : void 0;
  }
};

var X = function X() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};

var Q = function Q(t) {
  return q(t) || R(t) || J(t) || X();
};

function U(t, e) {
  if (t) {
    var n = function (t) {
      var e = t.getBoundingClientRect();
      return {
        top: Math.round(e.top),
        left: Math.round(e.left),
        bottom: Math.round(e.bottom),
        right: Math.round(e.right),
        width: Math.round(e.width),
        height: Math.round(e.height)
      };
    }(t);

    if (!1 !== e) {
      var r = window.getComputedStyle(t);
      n.left = parseInt(r.marginLeft || 0), n.top = parseInt(r.marginTop || 0);
    }

    return n;
  }
}

function Z(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function G(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? Z(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Z(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var K = {
  name: "VDMenu",
  mixins: [z, {
    name: "Detachable",
    mixins: [{
      name: "Bootable",
      data: function data() {
        return {
          isBooted: !1
        };
      },
      computed: {
        hasContent: function hasContent() {
          return this.isBooted || this.isActive;
        }
      },
      watch: {
        isActive: function isActive() {
          this.isBooted = !0;
        }
      },
      methods: {
        showLazyContent: function showLazyContent(t) {
          return this.hasContent && t ? t() : [this.$createElement()];
        }
      }
    }],
    props: {
      attach: {
        validator: B,
        default: !1
      },
      contentClass: {
        type: String,
        default: ""
      }
    },
    data: function data() {
      return {
        activatorNode: void 0,
        hasDetached: !1
      };
    },
    watch: {
      attach: function attach() {
        this.hasDetached = !1, this.initDetach();
      },
      hasContent: function hasContent() {
        this.$nextTick(this.initDetach);
      }
    },
    beforeMount: function beforeMount() {
      var t = this;
      this.$nextTick(function () {
        t.activatorNode && (Array.isArray(t.activatorNode) ? t.activatorNode : [t.activatorNode]).forEach(function (e) {
          if (e.elm && t.$el.parentNode) {
            var n = t.$el === t.$el.parentNode.firstChild ? t.$el : t.$el.nextSibling;
            t.$el.parentNode.insertBefore(e.elm, n);
          }
        });
      });
    },
    mounted: function mounted() {
      this.hasContent && this.initDetach();
    },
    deactivated: function deactivated() {
      this.isActive = !1;
    },
    beforeDestroy: function beforeDestroy() {
      try {
        if (this.$refs.content && this.$refs.content.parentNode && this.$refs.content.parentNode.removeChild(this.$refs.content), this.activatorNode) (Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode]).forEach(function (t) {
          t.elm && t.elm.parentNode && t.elm.parentNode.removeChild(t.elm);
        });
      } catch (t) {
        console.error(t);
      }
    },
    methods: {
      initDetach: function initDetach() {
        var t;
        this._isDestroyed || !this.$refs.content || this.hasDetached || "" === this.attach || !0 === this.attach || ((t = !1 === this.attach ? document.querySelector("#app") || document.querySelector("body") : "string" == typeof this.attach ? document.querySelector(this.attach) : this.attach) ? (t.appendChild(this.$refs.content), this.hasDetached = !0) : console.error("Unable to locate target '".concat(this.attach, "'"), this));
      }
    }
  }, {
    name: "DynamicPosition",
    data: function data() {
      return {
        activatorFixed: !1,
        dimensions: {
          activator: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0,
            offsetTop: 0,
            scrollHeight: 0,
            offsetLeft: 0
          },
          content: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0,
            offsetTop: 0,
            scrollHeight: 0
          }
        },
        isContentActive: !1,
        pageWidth: 0,
        pageYOffset: 0
      };
    },
    computed: {
      isAttached: function isAttached() {
        return !1 !== this.attach;
      },
      computedLeft: function computedLeft() {
        var t = this.dimensions,
            e = t.activator,
            n = t.content,
            r = (this.isAttached ? e.offsetLeft : e.left) || 0;
        return this.rtl ? e.right - n.width : r;
      },
      computedTop: function computedTop() {
        var t = this.dimensions.activator,
            e = t.height;
        return ((this.isAttached ? t.offsetTop : t.top + this.pageYOffset) || 0) + e;
      },
      hasActivator: function hasActivator() {
        return Boolean(this.$slots.activator) || Boolean(this.$scopedSlots.activator) || Boolean(this.activator);
      }
    },
    watch: {
      disabled: function disabled(t) {
        t && this.callDeactivate();
      },
      isActive: function isActive(t) {
        this.disabled || (t ? this.callActivate() : this.callDeactivate());
      }
    },
    methods: {
      activate: function activate() {},
      deactivate: function deactivate() {},
      callActivate: function callActivate() {
        this.activate();
      },
      callDeactivate: function callDeactivate() {
        this.isContentActive = !1, this.deactivate();
      },
      calcLeft: function calcLeft(t) {
        return F(this.isAttached ? this.computedLeft : this.calcXOverflow(this.computedLeft, t));
      },
      calcTop: function calcTop() {
        return F(this.isAttached ? this.computedTop : this.calcYOverflow(this.computedTop));
      },
      calcXOverflow: function calcXOverflow(t, e) {
        var n = t + e - this.pageWidth + 12;
        return (t = (!this.left || this.right) && n > 0 ? Math.max(t - n, 0) : Math.max(t, 12)) + (window.pageXOffset || document.documentElement.scrollLeft);
      },
      calcYOverflow: function calcYOverflow(t) {
        var e = this.pageYOffset + (window.innerHeight || document.documentElement.clientHeight),
            n = this.dimensions,
            r = n.activator,
            i = (n.content || {}).height,
            a = e < t + i;
        return a && r.top > i ? t = this.pageYOffset + (r.top - i) : a && !this.allowOverflow ? t = e - i - 12 : t < this.pageYOffset && !this.allowOverflow && (t = this.pageYOffset + 12), t < 12 ? 12 : t;
      },
      detectOrigin: function detectOrigin(t, e) {
        var n = parseInt(t.split("px")[0]),
            r = parseInt(e.split("px")[0]),
            i = this.dimensions.activator,
            a = [];
        return a.push(i.top < r - this.pageYOffset ? "top" : "bottom"), a.push(i.left === n ? "left" : "right"), this.origin || a.join(" ");
      },
      checkForPageYOffset: function checkForPageYOffset() {
        this.pageYOffset = this.activatorFixed ? 0 : window.pageYOffset || document.documentElement.scrollTop;
      },
      checkActivatorFixed: function checkActivatorFixed() {
        if (!this.isAttached) {
          var t = this.getActivator();

          this.activatorFixed = function (t) {
            for (var e = ["fixed", "sticky"], n = t; n;) {
              if (e.includes(window.getComputedStyle(n).position)) return !0;
              n = n.offsetParent;
            }

            return !1;
          }(t);
        }
      },
      sneakPeek: function sneakPeek(t) {
        var e = this;
        requestAnimationFrame(function () {
          var n = e.$refs.content;
          n && "none" === n.style.display ? (n.style.display = "inline-block", t(), n.style.display = "none") : t();
        });
      },
      startTransition: function startTransition() {
        var t = this;
        return new Promise(function (e) {
          return requestAnimationFrame(function () {
            t.isContentActive = t.isActive, e();
          });
        });
      },
      updateDimensions: function updateDimensions() {
        var t = this;
        this.checkActivatorFixed(), this.checkForPageYOffset(), this.pageWidth = window.innerWidth || document.documentElement.clientWidth;
        var e = {},
            n = this.getActivator();
        n && (e.activator = U(n, this.attach), e.activator.offsetLeft = n.offsetLeft, this.isAttached ? e.activator.offsetTop = n.offsetTop : e.activator.offsetTop = 0, this.sneakPeek(function () {
          e.content = U(t.$refs.content, t.attach), t.dimensions = e;
        }));
      }
    }
  }, {
    data: function data() {
      return {
        stackMinZIndex: 1e3
      };
    },
    computed: {
      activeZIndex: function activeZIndex() {
        var t = this.$refs.content,
            e = this.isActive ? this.getMaxZIndex() + 2 : V(t);
        return parseInt(e);
      }
    },
    methods: {
      getMaxZIndex: function getMaxZIndex() {
        var t = this.$el,
            e = Q(document.getElementsByClassName("menu__content--active")),
            n = [this.stackMinZIndex, V(t)].concat(Q(e.map(function (t) {
          return V(t);
        })));
        return Math.max.apply(Math, Q(n));
      }
    }
  }],
  directives: {
    Resize: {
      inserted: function inserted(t, e) {
        var n = e.value,
            r = e.options || {
          passive: !0
        },
            i = !1,
            a = function a() {
          i || (i = !0, window.requestAnimationFrame(n), i = !1);
        };

        window.addEventListener("resize", a, r), Object.assign(t, {
          onResize: {
            resizeCallback: a,
            options: r,
            running: i
          }
        }), e.modifiers && e.modifiers.quiet || a();
      },
      unbind: function unbind(t) {
        if (t.onResize) {
          var e = t.onResize,
              n = e.resizeCallback,
              r = e.options;
          window.removeEventListener("resize", n, r), delete t.onResize;
        }
      }
    }
  },
  props: {
    transition: {
      type: String,
      default: "menu-transition"
    },
    origin: {
      type: String,
      default: void 0
    },
    allowOverflow: {
      type: Boolean,
      default: !1
    },
    rtl: {
      type: Boolean,
      default: !1
    },
    minWidth: {
      type: [Number, String],
      default: void 0
    },
    maxWidth: {
      type: [Number, String],
      default: void 0
    },
    maxHeight: {
      type: [Number, String],
      default: "auto"
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    bottomSheet: {
      type: Boolean,
      default: !1
    }
  },
  data: function data() {
    return {
      resizeTimeout: 0,
      defaultOffset: 8
    };
  },
  computed: {
    styles: function styles() {
      return {
        maxHeight: this.calculedMenuMaxHeight,
        minWidth: this.calculedMenuWidth,
        maxWidth: this.calculedMaxWidth,
        top: this.calculedTop,
        left: this.calculedLeft,
        transformOrigin: this.detectedOrigin,
        zIndex: this.zIndex || this.activeZIndex
      };
    },
    calculedMenuMaxHeight: function calculedMenuMaxHeight() {
      return F(this.maxHeight);
    },
    calculedMaxWidth: function calculedMaxWidth() {
      return F(this.maxWidth);
    },
    calculedMenuWidth: function calculedMenuWidth() {
      if (this.minWidth) return F(this.minWidth);
      var t = Math.min(this.dimensions.activator.width, Math.max(this.pageWidth - 24, 0)),
          e = (parseInt(this.calculedMaxWidth) === 1 * this.calculedMaxWidth ? this.calculedMaxWidth : parseInt((this.calculedMaxWidth || "").split("px")[0])) || t;
      return F(Math.min(e, t));
    },
    calculedLeft: function calculedLeft() {
      var t = Math.max(this.dimensions.content.width, parseFloat(this.calculedMenuWidth));
      return this.calcLeft(t) || "0";
    },
    calculedTop: function calculedTop() {
      return this.calcTop() || "0";
    },
    detectedOrigin: function detectedOrigin() {
      return this.detectOrigin(this.calculedLeft, this.calculedTop);
    }
  },
  mounted: function mounted() {
    this.isActive && this.callActivate();
  },
  methods: {
    activate: function activate() {
      var t = this;
      this.updateDimensions(), requestAnimationFrame(function () {
        t.startTransition().then(function () {
          t.$emit("transitionEnd");
        });
      });
    },
    callDeactivate: function callDeactivate() {
      this.isContentActive = !1;
    },
    onResize: function onResize() {
      this.isActive && (this.$refs.content.offsetWidth, this.updateDimensions(), clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(this.updateDimensions, 100));
    },
    genTransition: function genTransition() {
      return this.$createElement("transition", {
        props: {
          name: this.transition
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var t = {
        attrs: {
          role: this.$attrs.role || "menu"
        },
        staticClass: "vd-menu__content",
        class: G(G({}, this.contentClass && a({}, this.contentClass, !0)), {}, {
          "vd-menu__content--active": this.isActive,
          "vd-menu__content--fixed": this.activatorFixed,
          "vd-menu__content--bottomsheet": this.bottomSheet
        }),
        style: this.styles,
        directives: [{
          name: "show",
          value: this.isContentActive
        }],
        ref: "content",
        on: {
          click: function click(t) {
            return t.stopPropagation();
          }
        }
      };
      return this.$createElement("div", t, [this.hasContent && this.getContentSlot()]);
    }
  },
  render: function render(t) {
    var e = this;
    return t("div", {
      staticClass: "vd-menu",
      class: {
        "menu--attached": this.isAttached
      },
      directives: [{
        arg: "500",
        name: "resize",
        value: this.onResize
      }]
    }, [!this.activator && this.genActivator(), this.showLazyContent(function () {
      return [e.genTransition()];
    })]);
  }
};

function tt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function et(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? tt(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tt(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function nt(t) {
  return Boolean(t) && Boolean(t.match(/^(#|(rgb|hsl)a?\()/));
}

var rt = {
  props: {
    color: {
      type: String
    }
  },
  methods: {
    setBackgroundColor: function setBackgroundColor(t, e) {
      return nt(t) ? e ? et(et({}, e), {}, {
        style: et(et({}, e.style), {}, {
          "background-color": "".concat(t),
          "border-color": "".concat(t)
        })
      }) : {
        "background-color": "".concat(t),
        "border-color": "".concat(t)
      } : e;
    },
    setTextColor: function setTextColor(t, e) {
      return nt(t) ? e ? et(et({}, e), {}, {
        style: et(et({}, e.style), {}, {
          color: "".concat(t)
        })
      }) : {
        color: "".concat(t)
      } : e;
    }
  }
},
    it = {
  close: {
    path: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
    viewBox: "0 0 320 512"
  },
  calendarAlt: {
    path: "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM148 320h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 96h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm192 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z",
    viewBox: "0 0 448 512"
  },
  chevronLeft: {
    path: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
    viewBox: "0 0 24 24"
  },
  chevronRight: {
    path: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    viewBox: "0 0 24 24"
  }
};

function at() {
  for (var t = arguments, e = arguments.length, n = new Array(e), i = 0; i < e; i++) {
    n[i] = t[i];
  }

  return r.extend({
    mixins: n
  });
}

function ot(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function st(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? ot(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ot(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var ct = at(rt).extend({
  name: "VDIcon",
  inheritAttrs: !1,
  props: {
    size: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasClickListener: function hasClickListener() {
      return Boolean(this.$listeners.click);
    }
  },
  methods: {
    getIconName: function getIconName() {
      return this.$slots.default ? this.$slots.default[0].text && this.$slots.default[0].text.trim() : "";
    },
    getIcon: function getIcon() {
      var t = this.getIconName();
      return it[t] || t;
    },
    getDefaultData: function getDefaultData() {
      return {
        staticClass: "vd-icon",
        class: {
          "vd-icon--disabled": this.disabled,
          "vd-icon--link": this.hasClickListener
        },
        attrs: st({
          "aria-hidden": !this.hasClickListener,
          disabled: this.hasClickListener && this.disabled,
          type: this.hasClickListener ? "button" : void 0
        }, this.$attrs),
        on: this.$listeners
      };
    },
    renderSvgIcon: function renderSvgIcon(t, e) {
      var n = this.hasClickListener ? "button" : "span",
          r = F(this.size),
          i = st(st({}, this.getDefaultData()), {}, {
        style: st({}, r && {
          fontSize: r,
          height: r,
          width: r
        })
      }),
          a = {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: t.viewBox,
          height: this.size || 16,
          width: this.size || 16,
          role: "img",
          "aria-hidden": !0,
          "data-icon": this.getIconName()
        }
      };
      return e(n, this.setTextColor(this.color, i), [e("svg", a, [e("path", {
        attrs: {
          fill: "currentColor",
          d: t.path
        }
      })])]);
    }
  },
  render: function render(t) {
    var e = this.getIcon();
    return this.renderSvgIcon(e, t);
  }
}),
    lt = at(rt).extend({
  name: "VDPickerCustomInput",
  inject: ["VDPicker"],
  props: {
    clearable: {
      type: Boolean
    },
    closeOnClickOutside: {
      type: Boolean,
      default: !0
    },
    color: {
      type: String
    },
    date: {
      type: [Object, Date, String]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    isDateDefined: {
      type: Boolean,
      default: !1
    },
    isMenuActive: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    noCalendarIcon: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String
    },
    tabindex: {
      type: [String, Number]
    }
  },
  computed: {
    classes: function classes() {
      return {
        "vd-picker__input--disabled": this.disabled,
        "vd-picker__input--is-active": this.isMenuActive,
        "vd-picker__input--no-date": !this.isDateDefined
      };
    },
    computedColor: function computedColor() {
      return this.disabled ? "" : this.isMenuActive ? this.color : "";
    },
    isDirty: function isDirty() {
      return this.isDateDefined;
    }
  },
  methods: {
    onKeyDown: function onKeyDown(t) {
      this.$emit("keydown", t);
    },
    clearableCallback: function clearableCallback() {
      this.$emit("clearDate");
    },
    genCalendarIcon: function genCalendarIcon() {
      var t = [];
      this.VDPicker.$slots["input-icon"] ? t.push(this.VDPicker.$slots["input-icon"]) : t.push(this.$createElement(ct, {
        props: {
          disabled: this.disabled
        }
      }, ["calendarAlt"]));
      var e = this.$createElement("div", {
        staticClass: "vd-picker__input-icon__wrapper"
      }, t);
      return this.$createElement("div", {
        staticClass: "vd-picker__input-icon"
      }, [e]);
    },
    genInput: function genInput() {
      return this.$createElement("input", {
        attrs: {
          id: this.id,
          name: this.name,
          disabled: this.disabled,
          "aria-disabled": this.disabled,
          placeholder: this.placeholder,
          tabindex: this.tabindex,
          role: "text",
          type: "text",
          readonly: !0,
          "aria-readonly": !0
        },
        domProps: {
          value: this.date
        },
        on: {
          keydown: this.onKeyDown
        },
        ref: "input"
      });
    },
    genClearIcon: function genClearIcon() {
      var t = this,
          e = this.isDirty ? "close" : "",
          n = {
        attrs: {
          "aria-label": "clearable icon",
          color: this.color,
          disabled: this.disabled
        },
        on: {
          click: function click(e) {
            e.preventDefault(), e.stopPropagation(), t.clearableCallback();
          },
          mouseup: function mouseup(t) {
            t.preventDefault(), t.stopPropagation();
          }
        }
      },
          r = this.$createElement("div", {
        staticClass: "vd-picker__input-clear__icon"
      }, [this.$createElement(ct, n, e)]);
      return this.$createElement("div", {
        staticClass: "vd-picker__input-clear"
      }, [r]);
    }
  },
  render: function render(t) {
    return t("div", this.setTextColor(this.computedColor, {
      staticClass: "vd-picker__input",
      class: this.classes
    }), [!this.noCalendarIcon && this.genCalendarIcon(), this.genInput(), this.clearable && this.genClearIcon()]);
  }
}),
    ut = at(rt, H).extend({
  name: "VDOverlay",
  props: {
    absolute: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "rgba(93, 106, 137)"
    },
    opacity: {
      type: [Number, String],
      default: .84
    },
    value: {
      default: !0
    },
    zIndex: {
      type: [Number, String],
      default: void 0
    }
  },
  computed: {
    classes: function classes() {
      return {
        "vd-overlay--absolute": this.absolute,
        "vd-overlay--active": this.isActive
      };
    },
    styles: function styles() {
      return {
        zIndex: this.zIndex
      };
    },
    computedOpacity: function computedOpacity() {
      return Number(this.isActive ? this.opacity : 0);
    },
    overlayInner: function overlayInner() {
      var t = this.setBackgroundColor(this.color, {
        staticClass: "vd-overlay__inner",
        style: {
          opacity: this.computedOpacity
        }
      });
      return this.$createElement("div", t);
    }
  },
  methods: {
    genContent: function genContent() {
      return this.$createElement("div", {
        staticClass: "vd-overlay__content"
      }, this.$slots.default);
    }
  },
  render: function render(t) {
    var e = [this.overlayInner];
    return this.isActive && e.push(this.genContent()), t("div", {
      staticClass: "vd-overlay",
      class: this.classes,
      style: this.styles
    }, e);
  }
}),
    dt = r.extend(ut),
    ht = r.extend({
  name: "Overlayable",
  props: {
    overlayColor: {
      type: String,
      default: void 0
    },
    overlayOpacity: {
      type: [Number, String],
      default: void 0
    }
  },
  data: function data() {
    return {
      overlay: void 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },
  methods: {
    scrollListener: function scrollListener(t) {
      if ("keydown" === t.type) {
        if (["INPUT", "TEXTAREA", "SELECT"].includes(t.target.tagName) || t.target.isContentEditable) return;
        var e = [w.up, w.pageup],
            n = [w.down, w.pagedown];
        if (e.includes(t.keyCode)) t.deltaY = -1;else {
          if (!n.includes(t.keyCode)) return;
          t.deltaY = 1;
        }
      }

      (t.target === this.overlay || "keydown" !== t.type && t.target === document.body || this.checkPath(t)) && t.preventDefault();
    },
    hasScrollbar: function hasScrollbar(t) {
      if (!t || t.nodeType !== Node.ELEMENT_NODE) return !1;
      var e = window.getComputedStyle(t);
      return ["auto", "scroll"].includes(e.overflowY) && t.scrollHeight > t.clientHeight;
    },
    shouldScroll: function shouldScroll(t, e) {
      return 0 === t.scrollTop && e < 0 || t.scrollTop + t.clientHeight === t.scrollHeight && e > 0;
    },
    isInside: function isInside(t, e) {
      return t === e || null !== t && t !== document.body && this.isInside(t.parentNode, e);
    },
    checkPath: function checkPath(t) {
      var e = t.path || this.composedPath(t),
          n = t.deltaY;

      if ("keydown" === t.type && e[0] === document.body) {
        var r = this.$refs.dialog,
            i = window.getSelection() && window.getSelection().anchorNode;
        return !(r && this.hasScrollbar(r) && this.isInside(i, r)) || this.shouldScroll(r, n);
      }

      for (var a = 0; a < e.length; a++) {
        var o = e[a];
        if (o === document) return !0;
        if (o === document.documentElement) return !0;
        if (o === this.$refs.content) return !0;
        if (this.hasScrollbar(o)) return this.shouldScroll(o, n);
      }

      return !0;
    },
    composedPath: function composedPath(t) {
      if (t.composedPath) return t.composedPath();

      for (var e = [], n = t.target; n;) {
        if (e.push(n), "HTML" === n.tagName) return e.push(document), e.push(window), e;
        n = n.parentElement;
      }

      return e;
    },
    hideScroll: function hideScroll() {
      window.addEventListener("wheel", this.scrollListener, {
        passive: !1
      }), window.addEventListener("keydown", this.scrollListener);
    },
    showScroll: function showScroll() {
      document.documentElement.classList.remove("overflow-y-hidden"), window.removeEventListener("wheel", this.scrollListener), window.removeEventListener("keydown", this.scrollListener);
    },
    createOverlay: function createOverlay() {
      var t = new dt({
        propsData: {
          absolute: this.absolute,
          value: !1,
          color: this.overlayColor,
          opacity: this.overlayOpacity
        }
      });
      t.$mount();
      var e = document.querySelector("#app") || document.querySelector("body"),
          n = this.absolute ? this.$el.parentNode : e;
      n && n.insertBefore(t.$el, n.firstChild), this.overlay = t;
    },
    genOverlay: function genOverlay() {
      var t = this;
      return this.hideScroll(), this.overlay || this.createOverlay(), requestAnimationFrame(function () {
        t.overlay && (void 0 !== t.activeZIndex ? t.overlay.zIndex = String(t.activeZIndex - 1) : t.$el && (t.overlay.zIndex = V(t.$el)), t.overlay.value = !0);
      }), !0;
    },
    removeOverlay: function removeOverlay() {
      var t = this,
          e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      this.overlay && (N(this.overlay.$el, "transitionend", function () {
        t.overlay && t.overlay.$el && t.overlay.$el.parentNode && !t.overlay.value && (t.overlay.$el.parentNode.removeChild(t.overlay.$el), t.overlay.$destroy(), t.overlay = null);
      }), this.overlay.value = !1), e && this.showScroll();
    }
  }
});

var pt = function pt(t) {
  if (Array.isArray(t)) return t;
};

var ft = function ft(t, e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
    var n = [],
        r = !0,
        i = !1,
        a = void 0;

    try {
      for (var o, s = t[Symbol.iterator](); !(r = (o = s.next()).done) && (n.push(o.value), !e || n.length !== e); r = !0) {
        ;
      }
    } catch (t) {
      i = !0, a = t;
    } finally {
      try {
        r || null == s.return || s.return();
      } finally {
        if (i) throw a;
      }
    }

    return n;
  }
};

var mt = function mt() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};

var vt = function vt(t, e) {
  return pt(t) || ft(t, e) || J(t, e) || mt();
},
    yt = $(function (t, e) {
  t.exports = function (t, e, n) {
    var r = e.prototype,
        i = r.format;
    n.en.ordinal = function (t) {
      var e = ["th", "st", "nd", "rd"],
          n = t % 100;
      return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
    }, r.format = function (t) {
      var e = this,
          n = this.$locale(),
          r = this.$utils(),
          a = (t || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|gggg|Do|X|x|k{1,2}|S/g, function (t) {
        switch (t) {
          case "Q":
            return Math.ceil((e.$M + 1) / 3);

          case "Do":
            return n.ordinal(e.$D);

          case "gggg":
            return e.weekYear();

          case "wo":
            return n.ordinal(e.week(), "W");

          case "w":
          case "ww":
            return r.s(e.week(), "w" === t ? 1 : 2, "0");

          case "k":
          case "kk":
            return r.s(String(0 === e.$H ? 24 : e.$H), "k" === t ? 1 : 2, "0");

          case "X":
            return Math.floor(e.$d.getTime() / 1e3);

          case "x":
            return e.$d.getTime();

          default:
            return t;
        }
      });
      return i.bind(this)(a);
    };
  };
}),
    gt = $(function (t, e) {
  t.exports = function (t, e) {
    e.prototype.isSameOrAfter = function (t, e) {
      return this.isSame(t, e) || this.isAfter(t, e);
    };
  };
}),
    bt = $(function (t, e) {
  t.exports = function (t, e) {
    e.prototype.isSameOrBefore = function (t, e) {
      return this.isSame(t, e) || this.isBefore(t, e);
    };
  };
}),
    Dt = $(function (t, e) {
  t.exports = function (t, e, n) {
    e.prototype.isToday = function () {
      var t = n();
      return this.format("YYYY-MM-DD") === t.format("YYYY-MM-DD");
    };
  };
}),
    _t = $(function (t, e) {
  var n, r;
  t.exports = (n = "month", r = "quarter", function (t, e) {
    var i = e.prototype;

    i.quarter = function (t) {
      return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
    };

    var a = i.add;

    i.add = function (t, e) {
      return t = Number(t), this.$utils().p(e) === r ? this.add(3 * t, n) : a.bind(this)(t, e);
    };

    var o = i.startOf;

    i.startOf = function (t, e) {
      var i = this.$utils(),
          a = !!i.u(e) || e;

      if (i.p(t) === r) {
        var s = this.quarter() - 1;
        return a ? this.month(3 * s).startOf(n).startOf("day") : this.month(3 * s + 2).endOf(n).endOf("day");
      }

      return o.bind(this)(t, e);
    };
  });
}),
    kt = $(function (t, e) {
  t.exports = function (t, e, n) {
    var r = new Date().getTimezoneOffset(),
        i = e.prototype;
    n.utc = function (t, n) {
      return new e({
        date: t,
        utc: !0,
        format: n
      });
    }, i.utc = function () {
      return n(this.toDate(), {
        locale: this.$L,
        utc: !0
      });
    }, i.local = function () {
      return n(this.toDate(), {
        locale: this.$L,
        utc: !1
      });
    };
    var a = i.parse;

    i.parse = function (t) {
      t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), a.call(this, t);
    };

    var o = i.init;

    i.init = function () {
      if (this.$u) {
        var t = this.$d;
        this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
      } else o.call(this);
    };

    var s = i.utcOffset;

    i.utcOffset = function (t) {
      var e = this.$utils().u;
      if (e(t)) return this.$u ? 0 : e(this.$offset) ? s.call(this) : this.$offset;
      var n,
          i = Math.abs(t) <= 16 ? 60 * t : t;
      return 0 !== t ? (n = this.local().add(i + r, "minute")).$offset = i : n = this.utc(), n;
    };

    var c = i.format;
    i.format = function (t) {
      var e = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
      return c.call(this, e);
    }, i.valueOf = function () {
      var t = this.$utils().u(this.$offset) ? 0 : this.$offset + r;
      return this.$d.valueOf() - 6e4 * t;
    }, i.isUTC = function () {
      return !!this.$u;
    }, i.toISOString = function () {
      return this.toDate().toISOString();
    }, i.toString = function () {
      return this.toDate().toUTCString();
    };
  };
}),
    Ot = $(function (t, e) {
  t.exports = function (t, e) {
    e.prototype.weekday = function (t) {
      var e = this.$locale().weekStart || 0,
          n = this.$W,
          r = (n < e ? n + 7 : n) - e;
      return this.$utils().u(t) ? r : this.subtract(r, "day").add(t, "day");
    };
  };
}),
    Mt = $(function (t, e) {
  var n, r;
  t.exports = (n = "week", r = "year", function (t, e) {
    var i = e.prototype;
    i.week = function (t) {
      if (void 0 === t && (t = null), null !== t) return this.add(7 * (t - this.week()), "day");
      var e = this.$locale().yearStart || 1;

      if (11 === this.month() && this.date() > 25) {
        var i = this.startOf(r).add(1, r).date(e),
            a = this.endOf(n);
        if (i.isBefore(a)) return 1;
      }

      var o = this.startOf(r).date(e).startOf(n).subtract(1, "millisecond"),
          s = this.diff(o, n, !0);
      return s < 0 ? this.startOf("week").week() : Math.ceil(s);
    }, i.weeks = function (t) {
      return void 0 === t && (t = null), this.week(t);
    };
  });
});

function wt() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "date";
  return v[t];
}

function Yt(t, e) {
  var n = t.regexText,
      r = t.startDate,
      i = t.endDate,
      a = n.replace(M, "".concat(r).concat(e ? "|" : "")).replace(M, "".concat(i).concat(e ? "|" : ""));
  return e ? a.split("|") : a;
}

function St(t) {
  return 3 * t;
}

function xt(t) {
  var e = t.date,
      n = t.min,
      r = t.max,
      i = t.type,
      a = void 0 === i ? "date" : i,
      o = t.allowedFn,
      s = e.format(wt(a));
  return (!o || o(s)) && (!n || $t(s, n, a) || jt(s, n, a)) && (!r || $t(s, r, a) || Lt(s, r, a));
}

function Ct(t) {
  var e = t.date,
      n = t.type,
      r = void 0 === n ? "date" : n,
      i = t.locale;
  return $t(Et({
    date: e,
    locale: i,
    format: wt(r)
  }), Et({
    date: void 0,
    locale: i,
    format: wt(r)
  }), "quarter" === r ? "month" : r);
}

function $t(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "date";
  return i(t, wt(n)).isSame(i(e, wt(n)), n);
}

function Lt(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "day";
  if ("year" === n) return Boolean(e) && t < i(e, "YYYY-MM-DD").get(n);
  var r = i.isDayjs(t) ? t : i(t).startOf("day");
  return Boolean(e) && r.isBefore(i(e).startOf("day"), n);
}

function jt(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "day";
  if ("year" === n) return Boolean(e) && t > i(e, "YYYY-MM-DD").get(n);
  var r = i.isDayjs(t) ? t : i(t).startOf("day");
  return Boolean(e) && r.isAfter(i(e).startOf("day"), n);
}

function Pt(t, e, n) {
  return jt(t, e) && Lt(t, n);
}

function Tt(t) {
  var e = t.date,
      n = t.locale,
      r = void 0 === n ? {
    lang: o
  } : n,
      a = t.type;
  return "year" === (void 0 === a ? "date" : a) ? i(e).utc() : i(e).locale(r.lang);
}

function Et(t) {
  var e = t.date,
      n = t.locale,
      r = t.format;
  return Tt({
    date: e,
    locale: n
  }).format(r);
}

function At(t) {
  var e = t.year,
      n = t.month;
  return Tt({
    locale: t.locale
  }).year(e).month(n).startOf("month");
}

function Ht(t) {
  var e = t.startDate,
      n = t.endDate,
      r = t.locale,
      i = t.interval,
      a = void 0 === i ? "day" : i,
      o = Tt({
    date: e,
    locale: r
  }),
      s = Tt({
    date: n,
    locale: r
  }).diff(o, a);
  return Q(Array(s + 1).keys()).map(function (t) {
    return o.add(t, a);
  });
}

function Nt(t) {
  var e = t.headerFormat,
      n = t.locale,
      r = t.date,
      i = t.range,
      a = t.rangeHeaderText;

  if (i && a) {
    var o = Ft({
      dates: r,
      locale: n,
      format: e
    }).split(" ~ "),
        s = vt(o, 2),
        c = Yt({
      regexText: a,
      startDate: s[0],
      endDate: s[1]
    }, !0),
        l = vt(c, 2),
        u = l[0],
        d = l[1];
    return [u.trim(), d.trim()];
  }

  return r ? Et({
    date: r,
    locale: n,
    format: e
  }) : "--";
}

function Bt(t) {
  var e = t.date,
      n = t.type,
      r = t.locale;
  if (e) return Et({
    date: e,
    locale: r,
    format: wt(n)
  });
}

function Ft(t) {
  var e = t.dates,
      n = void 0 === e ? {} : e,
      r = t.locale,
      i = t.format,
      a = n.start,
      o = n.end;
  return a || o ? !a && o ? "__ ~ ".concat(Tt({
    date: o,
    locale: r
  }).startOf("day").format(i)) : a && !o ? "".concat(Tt({
    date: a,
    locale: r
  }).startOf("day").format(i), " ~ __") : "".concat(Tt({
    date: a,
    locale: r
  }).startOf("day").format(i), " ~ ").concat(Tt({
    date: o,
    locale: r
  }).startOf("day").format(i)) : "__ ~ __";
}

i.extend(yt), i.extend(gt), i.extend(bt), i.extend(Dt), i.extend(_t), i.extend(kt), i.extend(Ot), i.extend(Mt);
var It = at(rt).extend({
  name: "VDPickerControls",
  props: {
    pickerDate: {
      type: Object,
      required: !0
    },
    transitionName: {
      type: String
    },
    color: {
      type: String
    },
    mode: {
      type: String,
      default: "date"
    },
    min: {
      type: [String, Number, Date]
    },
    max: {
      type: [String, Number, Date]
    }
  },
  computed: {
    monthFormatted: function monthFormatted() {
      return this.pickerDate.getMonthFormatted();
    },
    yearFormatted: function yearFormatted() {
      return this.pickerDate.getYearFormatted();
    },
    isPreviousDateDisabled: function isPreviousDateDisabled() {
      var t = ["month", "quarter"].includes(this.mode),
          e = parseInt(this.yearFormatted, 10) - 1;
      return Lt(t ? e : "".concat(this.yearFormatted, "-").concat(this.pickerDate.month), this.min, t ? "year" : "month");
    },
    isNextDateDisabled: function isNextDateDisabled() {
      var t = ["month", "quarter"].includes(this.mode),
          e = parseInt(this.yearFormatted, 10) + 1;
      return jt(t ? e : "".concat(this.yearFormatted, "-").concat(this.pickerDate.month + 2), this.max, t ? "year" : "month");
    }
  },
  methods: {
    onNavigationClick: function onNavigationClick(t) {
      this.$emit("on-navigation-click", t);
    },
    genPrevButton: function genPrevButton() {
      var t = this,
          e = this.$createElement(ct, "chevronLeft");
      return this.$createElement("button", {
        staticClass: "vd-picker__controls-prev",
        attrs: {
          disabled: this.isPreviousDateDisabled,
          type: "button"
        },
        on: {
          click: function click() {
            return t.onNavigationClick("prev");
          }
        }
      }, [e]);
    },
    genNextButton: function genNextButton() {
      var t = this,
          e = this.$createElement(ct, "chevronRight");
      return this.$createElement("button", {
        staticClass: "vd-picker__controls-next",
        attrs: {
          disabled: this.isNextDateDisabled,
          type: "button"
        },
        on: {
          click: function click() {
            return t.onNavigationClick("next");
          }
        }
      }, [e]);
    },
    genSelectors: function genSelectors() {
      return this.$createElement("div", {
        staticClass: "vd-picker__controls-wrapper"
      }, ["date" === this.mode && this.genMonthSelector(), this.genYearSelector()]);
    },
    genChildrenSelectors: function genChildrenSelectors(t) {
      var e = this,
          n = t.value,
          r = t.key,
          i = t.type;
      return this.$createElement("div", this.setTextColor(this.color, {
        key: r,
        staticClass: "vd-picker__controls-label"
      }), [this.$createElement("button", {
        attrs: {
          type: "button"
        },
        on: {
          click: function click() {
            return e.$emit("update-mode", i);
          }
        }
      }, [n])]);
    },
    genMonthSelector: function genMonthSelector() {
      var t = this;
      return this.$createElement("transition-group", {
        staticClass: "vd-picker__controls-month",
        props: {
          name: this.transitionName,
          tag: "span"
        }
      }, [this.pickerDate.month].map(function (e) {
        return t.genChildrenSelectors({
          value: t.monthFormatted,
          key: e,
          type: "month"
        });
      }));
    },
    genYearSelector: function genYearSelector() {
      var t = this;
      return this.$createElement("transition-group", {
        staticClass: "vd-picker__controls-year",
        class: {
          "vd-picker__controls-year--center": ["month", "quarter"].includes(this.mode)
        },
        props: {
          name: this.transitionName,
          tag: "span"
        }
      }, [this.pickerDate.year].map(function (e) {
        return t.genChildrenSelectors({
          value: t.yearFormatted,
          key: e,
          type: "year"
        });
      }));
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-picker__controls"
    }, [this.genPrevButton(), this.genSelectors(), this.genNextButton()]);
  }
});

function Vt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function zt(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? Vt(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vt(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var Wt = at(rt).extend({
  name: "VDPickerHeader",
  props: {
    formattedHeaderYear: {
      type: String
    },
    formattedHeaderDate: {
      type: [Array, String]
    },
    color: {
      type: String
    },
    mode: {
      type: String
    },
    mutableDate: {
      type: [String, Object]
    },
    range: {
      type: Boolean
    },
    transitionName: {
      type: String
    },
    type: {
      tpye: Boolean
    }
  },
  computed: {
    classes: function classes() {
      return a({
        "vd-picker-header--range": this.range
      }, "vd-picker-header--".concat(this.type), this.type);
    },
    year: function year() {
      return this.mutableDate ? this.formattedHeaderYear : "-";
    },
    dateFormatted: function dateFormatted() {
      return this.formattedHeaderDate;
    },
    isDateVisible: function isDateVisible() {
      return !this.range && "year" !== this.type;
    }
  },
  methods: {
    genYear: function genYear() {
      var t = this,
          e = this.$createElement("span", {
        staticClass: "vd-picker-header__year-button",
        on: {
          click: function click() {
            return t.$emit("update-mode", "year");
          }
        }
      }, [this.year]),
          n = {
        staticClass: "vd-picker-header__year",
        class: {
          "vd-picker-header__year--active": "year" === this.mode
        }
      };
      return this.$createElement("div", n, [e]);
    },
    genDate: function genDate() {
      var t = this,
          e = this.genTransitionGroup({
        date: this.dateFormatted,
        isActive: "year" !== this.mode,
        onClick: function onClick() {
          return t.$emit("update-mode", "date");
        }
      });
      return this.$createElement("div", {
        staticClass: "vd-picker-header__wrap"
      }, [e]);
    },
    genRangeDate: function genRangeDate() {
      var t = this.genTransitionGroup({
        date: this.dateFormatted[0],
        isActive: Boolean(this.mutableDate.start)
      }),
          e = this.genTransitionGroup({
        date: this.dateFormatted[1],
        isActive: Boolean(this.mutableDate.end)
      });
      return this.$createElement("div", {
        staticClass: "vd-picker-header__wrap"
      }, [t, e]);
    },
    genTransitionGroup: function genTransitionGroup(t) {
      var e = this,
          n = t.date,
          r = t.isActive,
          i = t.onClick;
      return this.$createElement("transition-group", {
        staticClass: "vd-picker-header__date",
        class: {
          "vd-picker-header__date--active": r
        },
        props: {
          name: this.transitionName,
          tag: "div"
        }
      }, [n].map(function (t) {
        return function (t) {
          return e.$createElement("span", {
            staticClass: "vd-picker-header__wrap-button",
            key: t,
            on: zt({}, i && {
              click: i
            })
          }, [t]);
        }(t);
      }));
    }
  },
  render: function render(t) {
    return t("div", this.setBackgroundColor(this.color, {
      staticClass: "vd-picker-header",
      class: this.classes
    }), [!this.range && this.genYear(), this.isDateVisible && this.genDate(), this.range && this.genRangeDate()]);
  }
});

function qt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Rt(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? qt(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qt(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var Jt = at(rt, x).extend({
  name: "VDPickerPresets",
  props: {
    rangePresets: {
      type: Array
    },
    mutableDate: {
      type: Object
    },
    minDate: {
      type: [String, Number, Date]
    },
    maxDate: {
      type: [String, Number, Date]
    },
    color: {
      type: String
    }
  },
  computed: {
    presetsFormatted: function presetsFormatted() {
      var t = this;
      if (this.rangePresets) return this.rangePresets.map(function (e) {
        return Rt(Rt({}, e), {}, {
          availableDates: (n = {
            dates: e.dates,
            minDate: t.minDate,
            maxDate: t.maxDate,
            locale: t.currentLocale
          }, r = n.dates, a = void 0 === r ? {} : r, o = n.minDate, s = n.maxDate, c = n.locale, l = a.start, u = a.end, d = o || Tt({
            locale: c
          }).year(g), h = s || Tt({
            locale: c
          }).year(b), Ht({
            startDate: l,
            endDate: u,
            locale: c
          }).filter(function (t) {
            return t.isSameOrAfter(d, "day") && t.isSameOrBefore(i(h, "day"));
          }))
        });
        var n, r, a, o, s, c, l, u, d, h;
      }).splice(0, 6);
    }
  },
  methods: {
    isPresetSelected: function isPresetSelected() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.availableDates,
          n = void 0 === e ? [] : e;
      return !(0 === n.length || !this.mutableDate) && $t(n[0], this.mutableDate.start) && $t(n[n.length - 1], this.mutableDate.end);
    },
    isPresetValid: function isPresetValid() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.availableDates,
          n = void 0 === e ? [] : e;
      return !!this.mutableDate && n.length > 0;
    },
    setPresetDates: function setPresetDates(t) {
      var e = t.availableDates;
      this.isPresetSelected({
        availableDates: e
      }) || this.$emit("update-range", {
        start: e[0],
        end: e[e.length - 1]
      });
    },
    genWrapper: function genWrapper() {
      return this.$createElement("div", {
        staticClass: "vd-picker-presets__wrapper"
      }, this.presetsFormatted.map(this.genButton));
    },
    genButton: function genButton(t, e) {
      var n = this,
          r = this.$createElement("div", this.setBackgroundColor(this.color, {
        staticClass: "vd-picker-preset__effect"
      })),
          i = this.$createElement("div", {
        staticClass: "vd-picker-preset__name",
        domProps: {
          innerHTML: t.name
        }
      });
      return this.$createElement("button", {
        key: e,
        staticClass: "vd-picker-preset",
        class: {
          "vd-picker-preset--selected": this.isPresetSelected(t),
          "vd-picker-preset--disabled": !this.isPresetValid(t)
        },
        attrs: {
          type: "button"
        },
        on: {
          click: function click() {
            return n.setPresetDates(t);
          }
        }
      }, [r, i]);
    }
  },
  render: function render(t) {
    if (this.presetsFormatted) return t("div", {
      staticClass: "vd-picker-presets"
    }, [this.genWrapper()]);
  }
});

function Xt(t, e) {
  var n = t.changedTouches[0];
  e.touchendX = n.clientX, e.touchendY = n.clientY, e.end && e.end(Object.assign(t, e)), function (t) {
    var e = t.touchstartX,
        n = t.touchendX,
        r = t.touchstartY,
        i = t.touchendY;
    t.offsetX = n - e, t.offsetY = i - r, Math.abs(t.offsetY) < .5 * Math.abs(t.offsetX) && (t.left && n < e - 16 && t.left(t), t.right && n > e + 16 && t.right(t)), Math.abs(t.offsetX) < .5 * Math.abs(t.offsetY) && (t.up && i < r - 16 && t.up(t), t.down && i > r + 16 && t.down(t));
  }(e);
}

function Qt(t) {
  var e = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: t.left,
    right: t.right,
    up: t.up,
    down: t.down,
    start: t.start,
    move: t.move,
    end: t.end
  };
  return {
    touchstart: function touchstart(t) {
      return function (t, e) {
        var n = t.changedTouches[0];
        e.touchstartX = n.clientX, e.touchstartY = n.clientY, e.start && e.start(Object.assign(t, e));
      }(t, e);
    },
    touchend: function touchend(t) {
      return Xt(t, e);
    },
    touchmove: function touchmove(t) {
      return function (t, e) {
        var n = t.changedTouches[0];
        e.touchmoveX = n.clientX, e.touchmoveY = n.clientY, e.move && e.move(Object.assign(t, e));
      }(t, e);
    }
  };
}

var Ut = {
  inserted: function inserted(t, e, n) {
    var r = e.value,
        i = r.parent ? t.parentElement : t,
        a = r.options || {
      passive: !0
    };

    if (i) {
      var o = Qt(e.value);
      i._touchHandlers = Object(i._touchHandlers), i._touchHandlers[n.context._uid] = o, Object.keys(o).forEach(function (t) {
        i.addEventListener(t, o[t], a);
      });
    }
  },
  unbind: function unbind(t, e, n) {
    var r = e.value.parent ? t.parentElement : t;

    if (r && r._touchHandlers) {
      var i = r._touchHandlers[n.context._uid];
      Object.keys(i).forEach(function (t) {
        r.removeEventListener(t, i[t]);
      }), delete r._touchHandlers[n.context._uid];
    }
  }
};

function Zt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

var Gt = at(rt, x).extend({
  name: "VDPickerTableDay",
  inject: ["VDPicker"],
  props: {
    allowedDates: {
      type: Function
    },
    color: {
      type: String
    },
    day: {
      type: Object,
      required: !0
    },
    maxDate: {
      type: [String, Number, Date]
    },
    minDate: {
      type: [String, Number, Date]
    },
    mutableDate: {
      type: [String, Object]
    },
    range: {
      type: Boolean
    },
    rangeCurrentHoveredDay: {
      type: String,
      default: void 0
    }
  },
  computed: {
    classes: function classes() {
      return {
        "vd-picker__table-day--selected": this.isSelected && !this.isDisabled,
        "vd-picker__table-day--between": this.range && this.isBetween,
        "vd-picker__table-day--in-range": this.range && this.isInRange,
        "vd-picker__table-day--first": this.range && this.firstInRange,
        "vd-picker__table-day--last": this.range && this.lastInRange && Boolean(this.mutableDate.end),
        "vd-picker__table-day--select-start": this.range && !this.mutableDate.start,
        "vd-picker__table-day--select-end": this.range && this.mutableDate.start && !this.mutableDate.end,
        "vd-picker__table-day--disabled": this.isDisabled
      };
    },
    formattedDay: function formattedDay() {
      return this.day.format("D");
    },
    isCurrent: function isCurrent() {
      return Ct({
        date: this.day,
        type: "date",
        locale: this.currentLocale
      });
    },
    isSelected: function isSelected() {
      return this.range ? [].concat(Q(this.mutableDate.start ? [this.mutableDate.start.startOf("day").unix()] : []), Q(this.mutableDate.end ? [this.mutableDate.end.startOf("day").unix()] : [])).includes(this.day.unix()) : this.mutableDate && this.mutableDate.startOf("day").unix() === this.day.unix();
    },
    isBetween: function isBetween() {
      return !(!this.mutableDate.start && !this.mutableDate.end) && Pt(this.day, this.mutableDate.start, this.mutableDate.end);
    },
    isInRange: function isInRange() {
      return !!this.rangeCurrentHoveredDay && (Lt(this.rangeCurrentHoveredDay, this.mutableDate.end) ? Pt(this.day, this.rangeCurrentHoveredDay, this.mutableDate.end) : Pt(this.day, this.mutableDate.start, this.rangeCurrentHoveredDay));
    },
    firstInRange: function firstInRange() {
      return this.mutableDate.start && this.mutableDate.start.startOf("day").unix() === this.day.unix();
    },
    lastInRange: function lastInRange() {
      return this.mutableDate.end && this.mutableDate.end.startOf("day").unix() === this.day.unix();
    },
    isDateAllowed: function isDateAllowed() {
      return xt({
        date: this.day,
        min: this.minDate,
        max: this.maxDate,
        allowedFn: this.allowedDates
      });
    },
    isDisabled: function isDisabled() {
      return !this.isDateAllowed;
    },
    scopedSlotDay: function scopedSlotDay() {
      return I(this.VDPicker, "day");
    }
  },
  methods: {
    onDayClick: function onDayClick(t) {
      this.$emit("select-day", t);
    },
    genWrapper: function genWrapper() {
      return this.$createElement("div", {
        staticClass: "vd-picker__table-day__wrapper",
        attrs: {
          "data-date": this.day.format("YYYY-MM-DD")
        }
      }, [this.isCurrent && this.genDayCurrent(), this.genDayEffect(), this.genDayText()]);
    },
    genDayCurrent: function genDayCurrent() {
      return this.$createElement("span", {
        staticClass: "vd-picker__table-day__current"
      });
    },
    genDayEffect: function genDayEffect() {
      return this.$createElement("span", {
        staticClass: "vd-picker__table-day__effect"
      });
    },
    genDayText: function genDayText() {
      if (!this.scopedSlotDay) return this.$createElement("span", {
        staticClass: "vd-picker__table-day__text"
      }, [this.formattedDay]);
      var t = {
        formattedDay: this.formattedDay,
        isCurrent: this.isToday,
        isSelected: this.isSelected && !this.isDisabled,
        isBetween: this.range && this.isBetween,
        isInRange: this.range && this.isInRange,
        isFirstRangeDay: this.range && this.firstInRange,
        isLastRangeDay: this.range && this.lastInRange && Boolean(this.mutableDate.end),
        isFirstSelectedDay: this.range && !this.mutableDate.start,
        isLastSelectedDay: this.range && this.mutableDate.start && !this.mutableDate.end,
        isDisabled: this.isDisabled
      },
          e = this.VDPicker.$scopedSlots.day(function (t) {
        for (var e = arguments, n = 1; n < arguments.length; n++) {
          var r = null != e[n] ? e[n] : {};
          n % 2 ? Zt(Object(r), !0).forEach(function (e) {
            a(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zt(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({
        day: this.formattedDay
      }, t));
      return this.$createElement("span", {
        staticClass: "vd-picker__table-day__text"
      }, [e]);
    }
  },
  render: function render(t) {
    var e = this,
        n = {
      staticClass: "vd-picker__table-day",
      class: this.classes,
      attrs: {
        type: "button",
        disabled: this.isDisabled,
        "data-date": this.day.format("YYYY-MM-DD")
      },
      on: {
        click: function click() {
          return e.onDayClick(e.day);
        }
      }
    };
    return t("button", this.setTextColor(this.color, n), [this.genWrapper()]);
  }
}),
    Kt = at(rt).extend({
  name: "VDPickerTableDate",
  directives: {
    Touch: Ut
  },
  props: {
    allowedDates: {
      type: Function
    },
    color: {
      type: String
    },
    pickerDate: {
      type: [String, Object]
    },
    isRangeSelected: {
      type: Boolean
    },
    maxDate: {
      type: [String, Number, Date]
    },
    minDate: {
      type: [String, Number, Date]
    },
    mutableDate: {
      type: [String, Object]
    },
    range: {
      type: Boolean
    },
    transitionName: {
      type: String
    }
  },
  data: function data() {
    return {
      rangeCurrentHoveredDay: void 0
    };
  },
  computed: {
    weekDays: function weekDays() {
      return this.pickerDate.getWeekDays();
    },
    spaceBeforeFirstDay: function spaceBeforeFirstDay() {
      return Q(Array(this.pickerDate.getWeekStart()).keys());
    }
  },
  watch: {
    rangeCurrentHoveredDay: function rangeCurrentHoveredDay(t) {
      t && this.$emit("update-hovered-day", t);
    }
  },
  methods: {
    onDayClick: function onDayClick(t) {
      this.rangeCurrentHoveredDay = void 0, this.$emit("select-date", t);
    },
    handleMouseMove: function handleMouseMove(t) {
      var e = t.target,
          n = "string" == typeof e.className && "vd-picker__table-days" === e.className.split(" ")[0];

      if (this.range && !this.isRangeSelected && !n) {
        var r = e.dataset.date;
        if (!r) return this.handleMouseMove({
          target: e.parentNode
        });
        var i = r === this.rangeCurrentHoveredDay;
        r && !i && (this.rangeCurrentHoveredDay = e.dataset.date);
      }
    },
    genWeek: function genWeek() {
      var t = this;
      return this.$createElement("div", {
        staticClass: "vd-picker__table-week"
      }, this.weekDays.map(function (e, n) {
        return t.$createElement("div", {
          key: n,
          domProps: {
            innerHTML: e
          },
          staticClass: "vd-picker__table-weekday"
        });
      }));
    },
    genDaysWrapper: function genDaysWrapper() {
      return this.$createElement("transition-group", {
        staticClass: "vd-picker__table-days__wrapper",
        props: {
          name: this.transitionName,
          tag: "div"
        }
      }, [this.pickerDate].map(this.genDays));
    },
    genDays: function genDays(t) {
      var e = this;
      return this.$createElement("div", {
        staticClass: "vd-picker__table-days",
        key: t.month,
        on: {
          mousemove: this.handleMouseMove
        }
      }, [this.spaceBeforeFirstDay.map(function (t) {
        return e.$createElement("div", {
          staticClass: "vd-picker__table-day",
          key: "space-".concat(t)
        });
      }), this.pickerDate.getDays().map(this.genDay)]);
    },
    genDay: function genDay(t, e) {
      return this.$createElement(Gt, {
        key: e,
        props: {
          allowedDates: this.allowedDates,
          color: this.color,
          day: t,
          maxDate: this.maxDate,
          minDate: this.minDate,
          mutableDate: this.mutableDate,
          range: this.range,
          rangeCurrentHoveredDay: this.rangeCurrentHoveredDay,
          locale: this.currentLocale
        },
        on: {
          "select-day": this.onDayClick
        }
      });
    }
  },
  render: function render(t) {
    var e = this;
    return t("div", {
      staticClass: "vd-picker__table",
      directives: [{
        name: "touch",
        value: {
          left: function left() {
            return e.$emit("update-month", "next");
          },
          right: function right() {
            return e.$emit("update-month", "prev");
          }
        }
      }],
      on: {
        touchstart: function touchstart(t) {
          return t.stopPropagation();
        }
      }
    }, [this.genWeek(), this.genDaysWrapper()]);
  }
}),
    te = {
  name: "VDPickerValidate",
  mixins: [rt],
  props: {
    buttonValidate: {
      type: String
    },
    buttonCancel: {
      type: String
    },
    color: {
      type: String
    },
    range: {
      type: Boolean
    },
    mutableDate: {
      type: Object
    }
  },
  computed: {
    isDisabledValidation: function isDisabledValidation() {
      return !!this.range && ("object" !== L(this.mutableDate) || !Object.values(this.mutableDate).every(function (t) {
        return Boolean(t);
      }));
    }
  },
  methods: {
    genButtonCancel: function genButtonCancel() {
      var t = this;
      return this.$createElement("button", {
        staticClass: "vd-picker-validate__button vd-picker-validate__button-cancel",
        attrs: {
          type: "button"
        },
        on: {
          click: function click() {
            return t.$emit("cancel");
          }
        }
      }, [this.genButtonEffect(), this.genButtonText(this.buttonCancel)]);
    },
    genButtonValidate: function genButtonValidate() {
      var t = this;
      return this.$createElement("button", this.setTextColor(this.color, {
        staticClass: "vd-picker-validate__button vd-picker-validate__button-validate",
        attrs: {
          type: "button",
          disabled: this.isDisabledValidation
        },
        on: {
          click: function click() {
            return t.$emit("validate");
          }
        }
      }), [this.genButtonEffect(), this.genButtonText(this.buttonValidate)]);
    },
    genButtonEffect: function genButtonEffect() {
      return this.$createElement("div", this.setBackgroundColor(this.color, {
        staticClass: "vd-picker-validate__effect"
      }));
    },
    genButtonText: function genButtonText(t) {
      return this.$createElement("div", {
        staticClass: "vd-picker-validate__name",
        domProps: {
          innerHTML: t
        }
      });
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-picker-validate"
    }, [this.genButtonCancel(), this.genButtonValidate()]);
  }
};

function ee(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ne(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? ee(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ee(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var re = at(rt, x).extend({
  name: "VDPickerMonths",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    allowedDates: {
      type: Function
    },
    color: {
      type: String,
      default: String
    },
    pickerDate: {
      type: Object,
      default: Object
    },
    max: {
      type: [String, Number, Date]
    },
    min: {
      type: [String, Number, Date]
    },
    mutableDate: {
      type: Object,
      default: void 0
    },
    range: {
      type: Boolean,
      default: !1
    },
    transitionName: {
      type: String,
      default: String
    },
    type: {
      type: String
    },
    visibleYearsNumber: {
      type: Number,
      default: 10
    }
  },
  computed: {
    yearFormatted: function yearFormatted() {
      return this.pickerDate.getYearFormatted();
    },
    getMonths: function getMonths() {
      return this.pickerDate.getMonths();
    }
  },
  methods: {
    isCurrent: function isCurrent(t) {
      return Ct({
        date: At({
          year: this.pickerDate.year,
          month: t,
          locale: this.currentLocale
        }),
        type: "month",
        locale: this.currentLocale
      });
    },
    isSelected: function isSelected(t) {
      if (this.range || !this.mutableDate) return !1;
      var e = At({
        year: this.pickerDate.year,
        month: t,
        locale: this.currentLocale
      });
      return $t(this.mutableDate.format("YYYY-MM"), e.format("YYYY-MM"), "month");
    },
    isAllowed: function isAllowed(t) {
      return xt({
        date: At({
          year: this.yearFormatted,
          month: t,
          locale: this.currentLocale
        }),
        min: this.min,
        max: this.max,
        type: "month",
        allowedFn: this.allowedDates
      });
    },
    genTransition: function genTransition() {
      return this.$createElement("transition-group", {
        staticClass: "vd-picker__months-inner",
        props: {
          tag: "div",
          name: this.transitionName
        }
      }, [this.pickerDate.year].map(this.genMonthList));
    },
    genMonthList: function genMonthList(t) {
      return this.$createElement("div", {
        staticClass: "vd-picker__months-list",
        key: t
      }, [this.getMonths.map(this.genMonthButton)]);
    },
    genMonthButton: function genMonthButton(t, e) {
      var n = this,
          r = this.isCurrent(e) && !this.isSelected(e),
          i = this.isSelected(e),
          a = this.$createElement("button", {
        key: e,
        staticClass: "vd-picker__months-button",
        style: ne(ne({}, r && {
          "border-color": this.color
        }), i && ne(ne({}, this.setTextColor("#fff")), this.setBackgroundColor(this.color))),
        attrs: {
          type: "button",
          disabled: !this.isAllowed(e)
        },
        on: {
          click: function click() {
            return n.$emit("input", e, "month");
          }
        }
      }, [t]);
      return this.$createElement("div", {
        staticClass: "vd-picker__months-button__wrapper"
      }, [a]);
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-picker__months"
    }, [this.genTransition()]);
  }
});

function ie(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ae(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? ie(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ie(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var oe = at(rt, x).extend({
  name: "VDPickerQuarters",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    allowedDates: {
      type: Function
    },
    color: {
      type: String,
      default: String
    },
    pickerDate: {
      type: Object,
      default: Object
    },
    max: {
      type: [String, Number, Date]
    },
    min: {
      type: [String, Number, Date]
    },
    mutableDate: {
      type: Object,
      default: void 0
    },
    transitionName: {
      type: String,
      default: String
    }
  },
  computed: {
    getQuarters: function getQuarters() {
      return this.pickerDate.getQuarters();
    }
  },
  methods: {
    isCurrent: function isCurrent(t) {
      return Ct({
        date: At({
          year: this.pickerDate.year,
          month: t,
          locale: this.currentLocale
        }),
        type: "quarter",
        locale: this.currentLocale
      });
    },
    isSelected: function isSelected(t) {
      if (!this.mutableDate) return !1;
      var e = At({
        year: this.pickerDate.year,
        month: t,
        locale: this.currentLocale
      });
      return $t(this.mutableDate.format("YYYY-MM"), e.format("YYYY-MM"), "month");
    },
    isAllowed: function isAllowed(t) {
      return xt({
        date: At({
          year: this.pickerDate.year,
          month: t,
          locale: this.currentLocale
        }),
        min: this.min,
        max: this.max,
        type: "month",
        allowedFn: this.allowedDates
      });
    },
    genTransition: function genTransition() {
      return this.$createElement("transition-group", {
        staticClass: "vd-picker__quarters-inner",
        props: {
          tag: "div",
          name: this.transitionName
        }
      }, [this.pickerDate.year].map(this.genQuarterList));
    },
    genQuarterList: function genQuarterList(t) {
      return this.$createElement("div", {
        staticClass: "vd-picker__quarters-list",
        key: t
      }, [this.getQuarters.map(this.genQuarterButton)]);
    },
    genQuarterButton: function genQuarterButton(t, e) {
      var n = this,
          r = St(e),
          i = this.isCurrent(r) && !this.isSelected(r),
          a = this.isSelected(r),
          o = this.$createElement("button", {
        key: e,
        staticClass: "vd-picker__quarters-button",
        style: ae(ae({}, i && {
          "border-color": this.color
        }), a && ae(ae({}, this.setTextColor("#fff")), this.setBackgroundColor(this.color))),
        attrs: {
          type: "button",
          disabled: !this.isAllowed(e)
        },
        on: {
          click: function click() {
            return n.$emit("input", e, "quarter");
          }
        }
      }, [t]);
      return this.$createElement("div", {
        staticClass: "vd-picker__quarters-button__wrapper"
      }, [o]);
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-picker__quarters"
    }, [this.genTransition()]);
  }
});

function se(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ce(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? se(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : se(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var le = at(rt).extend({
  name: "VDPickerYears",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    allowedDates: {
      type: Function
    },
    color: {
      type: String,
      default: String
    },
    mutableDate: {
      type: Object,
      default: void 0
    },
    pickerDate: {
      type: Object,
      default: Object
    },
    max: {
      type: [String, Number, Date]
    },
    min: {
      type: [String, Number, Date]
    },
    visibleYearsNumber: {
      type: Number,
      default: 10
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    yearFormatted: function yearFormatted() {
      return this.pickerDate.getYearFormatted();
    },
    activeYear: function activeYear() {
      if (!this.range) return this.mutableDate && this.mutableDate.format("YYYY");
    },
    getYears: function getYears() {
      return this.pickerDate.generateYearsRange({
        activeYear: this.activeYear,
        visibleYearsNumber: this.visibleYearsNumber,
        min: this.min,
        max: this.max
      });
    }
  },
  watch: {
    active: {
      handler: function handler(t) {
        t && !this.range && setTimeout(this.computeScrollPosition);
      },
      immediate: !0
    }
  },
  methods: {
    isCurrent: function isCurrent(t) {
      return Ct({
        date: At({
          year: t,
          month: 0,
          locale: this.currentLocale
        }),
        type: "year",
        locale: this.currentLocale
      });
    },
    isSelected: function isSelected(t) {
      return this.activeYear === String(t);
    },
    isAllowed: function isAllowed(t) {
      return xt({
        date: At({
          year: t,
          month: 0,
          locale: this.currentLocale
        }),
        min: this.min,
        max: this.max,
        type: "year",
        allowedFn: this.allowedDates
      });
    },
    computeScrollPosition: function computeScrollPosition() {
      var t = this.$el.getElementsByClassName("active")[0];

      this.$el.scrollTop = function (t) {
        var e = t.activeItem,
            n = t.container,
            r = t.min,
            i = t.max;
        return e ? e.offsetTop - n.offsetHeight / 2 + e.offsetHeight / 2 : r || i ? 0 : n.scrollHeight / 2 - n.offsetHeight / 2;
      }({
        activeItem: t,
        container: this.$el,
        min: this.min,
        max: this.max
      });
    },
    genYearButton: function genYearButton(t) {
      var e = this,
          n = this.isCurrent(t) && !this.isSelected(t),
          r = this.isSelected(t);
      return this.$createElement("li", {
        key: t,
        staticClass: "vd-picker__years-button",
        class: {
          active: this.isSelected(t)
        },
        style: ce(ce({}, n && {
          "border-color": this.color
        }), r && ce(ce({}, this.setTextColor("#fff")), this.setBackgroundColor(this.color))),
        attrs: {
          disabled: !this.isAllowed(t)
        },
        on: {
          click: function click() {
            return e.$emit("input", t, "year");
          }
        }
      }, [t]);
    }
  },
  render: function render(t) {
    var e = this;
    return t("ul", {
      staticClass: "vd-picker__years"
    }, this.getYears.map(function (t) {
      return e.genYearButton(t);
    }));
  }
});

var ue = function ue(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
};

function de(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

var he = function he(t, e, n) {
  return e && de(t.prototype, e), n && de(t, n), t;
},
    pe = function () {
  function t(e, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
      lang: o
    };
    ue(this, t), i.locale(r.lang), this.locale = r, this.start = i().year(n).month(e).startOf("month"), this.end = this.start.endOf("month"), this.month = e, this.year = n;
  }

  return he(t, [{
    key: "getWeekStart",
    value: function value() {
      return this.start.weekday();
    }
  }, {
    key: "getDays",
    value: function value() {
      return Array.from(Ht({
        startDate: this.start,
        endDate: this.end,
        locale: this.locale
      }));
    }
  }, {
    key: "getWeekDays",
    value: function value() {
      var t = this.locale,
          e = t.lang,
          n = t.weekDays,
          r = Q(e.weekdaysShort);
      return e.weekStart && 1 === e.weekStart && r.push(r.shift()), n || r;
    }
  }, {
    key: "getMonths",
    value: function value() {
      return Array.apply(0, Array(12)).map(function (t, e) {
        return i().month(e).format("MMM");
      });
    }
  }, {
    key: "getQuarters",
    value: function value() {
      return Array.apply(0, Array(4)).map(function (t, e) {
        var n = i().quarter(e + 1).startOf("quarter").format("MMMM"),
            r = i().quarter(e + 1).endOf("quarter").format("MMMM");
        return "".concat(n, " - ").concat(r);
      });
    }
  }, {
    key: "getMonthFormatted",
    value: function value() {
      return this.start.format("MMMM");
    }
  }, {
    key: "getYearFormatted",
    value: function value() {
      return this.start.format("YYYY");
    }
  }, {
    key: "generateYearsRange",
    value: function value(t) {
      var e = t.activeYear,
          n = t.visibleYearsNumber,
          r = t.min,
          a = t.max,
          o = parseInt(e, 10) || parseInt(i().format("YYYY"), 10),
          s = a ? parseInt(a, 10) : o + n,
          c = Math.min(s, r ? parseInt(r, 10) : o - n);
      return Q(Array(s - c + 1).keys()).map(function (t) {
        return s - t;
      });
    }
  }]), t;
}();

function fe(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function me(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? fe(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : fe(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var ve = at(rt, ht, x).extend({
  name: "VDPickerAgenda",
  props: {
    allowedDates: {
      type: Function
    },
    buttonCancel: {
      type: String
    },
    buttonValidate: {
      type: String
    },
    color: {
      type: String
    },
    date: {
      type: [Date, Object]
    },
    headerFormat: {
      type: String
    },
    fullscreen: {
      type: Boolean,
      default: !1
    },
    maxDate: {
      type: [String, Number, Date]
    },
    minDate: {
      type: [String, Number, Date]
    },
    name: {
      type: String
    },
    noHeader: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    },
    rangeHeaderText: {
      type: String,
      default: String
    },
    rangePresets: {
      type: Array,
      default: void 0
    },
    rtl: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "date"
    },
    validate: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Boolean,
      default: !1
    },
    visibleYearsNumber: {
      type: Number
    }
  },
  data: function data() {
    return {
      height: "auto",
      pickerDate: void 0,
      mutableDate: void 0,
      mode: D,
      transitionDaysName: "slide-h-next",
      transitionLabelName: "slide-v-next"
    };
  },
  computed: {
    classes: function classes() {
      return {
        "vd-picker--rtl": this.rtl,
        "vd-picker--bottomsheet": this.fullscreen,
        "vd-picker--no-header": this.noHeader,
        "vd-picker--validate": this.validate,
        "vd-picker--range": this.range,
        "vd-picker--range-selecting": this.range && !this.isRangeSelected
      };
    },
    isRangeSelected: function isRangeSelected() {
      return !!this.range && "object" === L(this.mutableDate) && Object.values(this.mutableDate).every(function (t) {
        return Boolean(t);
      });
    },
    formatters: function formatters() {
      return t = {
        headerFormat: this.headerFormat,
        locale: this.locale,
        maxDate: this.maxDate,
        minDate: this.minDate,
        mutableDate: this.mutableDate,
        range: this.range,
        rangeHeaderText: this.rangeHeaderText
      }, e = t.headerFormat, n = t.locale, r = t.maxDate, i = t.minDate, a = t.mutableDate, o = t.range, s = t.rangeHeaderText, {
        formattedHeaderYear: Et({
          date: a,
          locale: n,
          format: "YYYY"
        }),
        formattedHeaderDate: Nt({
          date: a,
          headerFormat: e,
          locale: n,
          range: o,
          rangeHeaderText: s
        }),
        minDate: i,
        maxDate: r,
        minMonth: Bt({
          date: i,
          type: "month",
          locale: n
        }),
        maxMonth: Bt({
          date: r,
          type: "month",
          locale: n
        }),
        minYear: Bt({
          date: i,
          type: "year",
          locale: n
        }),
        maxYear: Bt({
          date: r,
          type: "year",
          locale: n
        })
      };
      var t, e, n, r, i, a, o, s;
    }
  },
  created: function created() {
    this.initAgenda();
  },
  beforeDestroy: function beforeDestroy() {
    t();
  },
  watch: {
    value: "initAgenda",
    date: "initDatesForPicker",
    type: "updateMode",
    fullscreen: {
      handler: function handler(t) {
        var r = this;
        this.$nextTick(function () {
          var i = r.$refs.body;
          t ? (e(i), r.genOverlay()) : (r.removeOverlay(!1), n(i));
        });
      },
      immediate: !0
    },
    mode: function mode(t) {
      var r = this;
      "year" === t && this.fullscreen && (n(this.$refs.body), this.$nextTick(function () {
        e(r.$el.querySelector(".vd-picker__years"));
      }));
    }
  },
  methods: {
    initAgenda: function initAgenda() {
      this.initDatesForPicker(this.date), this.updateMode(this.type);
    },
    updateTransitions: function updateTransitions(t) {
      this.transitionDaysName = "slide-h-".concat(t), this.transitionLabelName = "slide-v-".concat(t);
    },
    reOrderSelectedDate: function reOrderSelectedDate(t) {
      this.mutableDate && (Lt(t, this.mutableDate.start) ? this.mutableDate = {
        start: void 0,
        end: this.mutableDate.start
      } : jt(t, this.mutableDate.end) && (this.mutableDate = {
        start: this.mutableDate.end,
        end: void 0
      }));
    },
    selectDate: function selectDate(t) {
      if (this.range) return this.isRangeSelected || !this.mutableDate.start && !this.mutableDate.end ? void (this.mutableDate = {
        start: t.clone(),
        end: void 0
      }) : (this.reOrderSelectedDate(t), void this.emitSelectedDate(me(me(me({}, this.mutableDate), this.mutableDate.start && {
        end: t.clone()
      }), this.mutableDate.end && {
        start: t.clone()
      })));
      var e,
          n,
          r = (e = t, n = this.mutableDate, i(e).isAfter(i(n)) ? "next" : "prev");
      this.updateTransitions(r), this.emitSelectedDate(t.clone());
    },
    emitSelectedDate: function emitSelectedDate(t) {
      this.range && (this.pickerDate = new pe(t.end.month(), t.end.year(), this.currentLocale)), this.mutableDate = t, this.$emit("selectDate", this.mutableDate);
    },
    initDatesForPicker: function initDatesForPicker(t) {
      var e = Tt({
        date: this.range ? t.end || t.start : t,
        locale: this.currentLocale
      });
      if (jt(e, this.maxDate) && (e = Tt({
        date: this.maxDate,
        locale: this.currentLocale
      })), this.range) return this.pickerDate = new pe(e.month(), e.year(), this.currentLocale), void (this.mutableDate = t);
      null == t && "quarter" === this.type && (e = e.month(e.quarter())), null != t && "quarter" === this.type && (e = e.month(St(e.month()))), this.pickerDate = new pe(e.month(), e.year(), this.currentLocale), this.mutableDate = t && t.month(e.month()).clone();
    },
    changeMonth: function changeMonth(t) {
      var e = this.pickerDate.month + ("prev" === t ? -1 : 1),
          n = this.pickerDate.year;
      (e > 11 || e < 0) && (n += "prev" === t ? -1 : 1, e = "prev" === t ? 11 : 0), this.updateTransitions(t), this.pickerDate = new pe(e, n, this.currentLocale);
    },
    changeYear: function changeYear(t) {
      var e = this.pickerDate.year + ("prev" === t ? -1 : 1),
          n = this.pickerDate.month;
      this.updateTransitions(t), this.pickerDate = new pe(n, e, this.currentLocale);
    },
    updateMode: function updateMode(t) {
      this.mode = t;
    },
    updateSelectedYearMonth: function updateSelectedYearMonth(t, e) {
      var n = function (t, e, n) {
        return "year" === n ? {
          year: t,
          month: e.month
        } : "quarter" === n ? {
          year: e.year,
          month: St(t)
        } : {
          year: e.year,
          month: t
        };
      }(t, this.pickerDate, e),
          r = n.year,
          i = n.month;

      if (this.pickerDate = new pe(i, r, this.currentLocale), e === O && "year" !== this.type) {
        var a = "quarter" === this.type ? "quarter" : "month";
        return this.updateMode(a);
      }

      if ("date" === this.type) this.updateMode("date");else {
        var o = At({
          year: this.pickerDate.year,
          month: this.pickerDate.month,
          locale: this.currentLocale
        });
        this.selectDate(o);
      }
    },
    genTitle: function genTitle() {
      var t = this,
          e = this.$createElement("p", this.name),
          n = this.$createElement(ct, {
        on: {
          click: function click() {
            return t.$emit("close");
          }
        }
      }, ["close"]);
      return this.$createElement("div", {
        staticClass: "vd-picker__title"
      }, [e, this.$createElement("div", {
        staticClass: "vd-picker__title-close"
      }, [n])]);
    },
    genHeader: function genHeader() {
      return this.$createElement(Wt, {
        props: me(me({}, this.formatters), {}, {
          color: this.color,
          mode: this.yearMonthMode,
          mutableDate: this.mutableDate,
          range: this.range,
          transitionName: this.transitionLabelName,
          type: this.type
        }),
        on: {
          "update-mode": this.updateMode
        }
      });
    },
    genPresets: function genPresets() {
      return this.$createElement(Jt, {
        props: {
          rangePresets: this.rangePresets,
          mutableDate: this.mutableDate,
          minDate: this.minDate,
          maxDate: this.maxDate,
          color: this.color,
          locale: this.locale
        },
        on: {
          "update-range": this.emitSelectedDate
        }
      });
    },
    genBody: function genBody() {
      var t = [this.mode !== O && this.genControls(), this.mode === D && this.genTableDate(), this.mode === _ && this.genMonths(), this.mode === k && this.genQuarters(), this.mode === O && this.genYears()];
      return this.$createElement("div", {
        staticClass: "vd-picker__body",
        ref: "body"
      }, t);
    },
    genControls: function genControls() {
      return this.$createElement(It, {
        props: {
          pickerDate: this.pickerDate,
          transitionName: this.transitionLabelName,
          color: this.color,
          min: this.minDate,
          max: this.maxDate,
          mode: this.mode
        },
        on: {
          "on-navigation-click": this.mode === D ? this.changeMonth : this.changeYear,
          "update-mode": this.updateMode
        }
      });
    },
    genTableDate: function genTableDate() {
      return this.$createElement(Kt, {
        props: {
          allowedDates: this.allowedDates,
          color: this.color,
          pickerDate: this.pickerDate,
          isRangeSelected: this.isRangeSelected,
          locale: this.currentLocale,
          maxDate: this.maxDate,
          minDate: this.minDate,
          mutableDate: this.mutableDate,
          range: this.range,
          transitionName: this.transitionDaysName
        },
        on: {
          "update-month": this.changeMonth,
          "update-hovered-day": this.reOrderSelectedDate,
          "select-date": this.selectDate
        }
      });
    },
    genMonths: function genMonths() {
      var t = this.formatters,
          e = t.minMonth,
          n = t.maxMonth;
      return this.$createElement(re, {
        props: {
          active: this.mode === _,
          allowedDates: this.type === _ ? this.allowedDates : void 0,
          color: this.color,
          locale: this.currentLocale,
          max: n,
          min: e,
          mutableDate: this.mutableDate,
          pickerDate: this.pickerDate,
          range: this.range,
          transitionName: this.transitionDaysName
        },
        on: {
          input: this.updateSelectedYearMonth
        }
      });
    },
    genQuarters: function genQuarters() {
      var t = this.formatters,
          e = t.minMonth,
          n = t.maxMonth;
      return this.$createElement(oe, {
        props: {
          active: this.mode === k,
          allowedDates: this.type === k ? this.allowedDates : void 0,
          color: this.color,
          locale: this.currentLocale,
          max: n,
          min: e,
          mutableDate: this.mutableDate,
          pickerDate: this.pickerDate,
          transitionName: this.transitionDaysName
        },
        on: {
          input: this.updateSelectedYearMonth
        }
      });
    },
    genYears: function genYears() {
      var t = this.formatters,
          e = t.minYear,
          n = t.maxYear;
      return this.$createElement(le, {
        props: {
          active: this.mode === O,
          allowedDates: this.type === O ? this.allowedDates : void 0,
          color: this.color,
          max: n,
          min: e,
          mutableDate: this.mutableDate,
          pickerDate: this.pickerDate,
          range: this.range,
          visibleYearsNumber: this.visibleYearsNumber
        },
        on: {
          input: this.updateSelectedYearMonth
        }
      });
    },
    genValidate: function genValidate() {
      var t = this;
      return this.$createElement(te, {
        props: {
          buttonValidate: this.buttonValidate,
          buttonCancel: this.buttonCancel,
          color: this.color,
          mutableDate: this.mutableDate,
          range: this.range
        },
        on: {
          cancel: function cancel() {
            return t.$emit("close");
          },
          validate: function validate() {
            return t.$emit("validateDate");
          }
        }
      });
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-picker",
      class: this.classes,
      ref: "datepicker"
    }, [this.fullscreen && this.genTitle(), !this.noHeader && this.genHeader(), this.range && this.genPresets(), this.genBody(), this.validate && this.genValidate()]);
  }
});

function ye(t) {
  var e = t.message,
      n = t.vm;

  if (n) {
    if (n.$_alreadyWarned = n.$_alreadyWarned || [], n.$_alreadyWarned.includes(e)) return;
    n.$_alreadyWarned.push(e);
  }

  return "[VueDatePicker] ".concat(e) + (n ? function (t) {
    if (t._isVue && t.$parent) {
      for (var e = [], n = 0; t;) {
        if (e.length > 0) {
          var r = e[e.length - 1];

          if (r.constructor === t.constructor) {
            n++, t = t.$parent;
            continue;
          }

          n > 0 && (e[e.length - 1] = [r, n], n = 0);
        }

        e.push(t), t = t.$parent;
      }

      return "\n\nfound in\n\n" + e.map(function (t, e) {
        return "".concat(0 === e ? "---\x3e " : " ".repeat(5 + 2 * e)).concat(Array.isArray(t) ? "".concat(De(t[0]), "... (").concat(t[1], " recursive calls)") : De(t));
      }).join("\n");
    }

    return "\n\n(found in ".concat(De(t), ")");
  }(n) : "");
}

function ge(t, e) {
  var n = ye({
    message: t,
    vm: e
  });
  null != n && console.warn(n);
}

var be = /(?:^|[-_])(\w)/g;

function De(t, e) {
  if (t.$root === t) return "<Root>";
  var n = "function" == typeof t && null != t.cid ? t.options : t._isVue ? t.$options || t.constructor.options : t || {},
      r = n.name || n._componentTag,
      i = n.__file;

  if (!r && i) {
    var a = i.match(/([^/\\]+)\.vue$/);
    r = a && a[1];
  }

  return (r ? "<".concat(r.replace(be, function (t) {
    return t.toUpperCase();
  }).replace(/[-_]/g, ""), ">") : "<Anonymous>") + (i && !1 !== e ? " at ".concat(i) : "");
}

function _e(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ke(t) {
  for (var e = arguments, n = 1; n < arguments.length; n++) {
    var r = null != e[n] ? e[n] : {};
    n % 2 ? _e(Object(r), !0).forEach(function (e) {
      a(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _e(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

var Oe = {
  minWidth: "290px",
  maxWidth: "315px"
},
    Me = at(x, C).extend({
  name: "VDPicker",
  provide: function provide() {
    return {
      VDPicker: this
    };
  },
  directives: {
    ClickOutside: T
  },
  props: {
    id: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      default: "datepicker"
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    validate: {
      type: Boolean,
      default: !1
    },
    buttonValidate: {
      type: String,
      default: void 0
    },
    buttonCancel: {
      type: String,
      default: void 0
    },
    type: {
      type: String,
      default: "date"
    },
    range: {
      type: Boolean,
      default: !1
    },
    rangeInputText: {
      type: String,
      default: "%d ~ %d"
    },
    rangeHeaderText: {
      type: String,
      default: void 0
    },
    rangePresets: {
      type: Array,
      default: void 0
    },
    value: {
      type: [String, Object, Number, Date]
    },
    format: {
      type: String,
      default: void 0
    },
    formatHeader: {
      type: String,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: "YYYY-MM-DD"
    },
    color: {
      type: String,
      default: "#4f88ff"
    },
    contentClass: {
      type: String,
      default: ""
    },
    allowedDates: {
      type: Function
    },
    minDate: {
      type: [String, Number, Date]
    },
    maxDate: {
      type: [String, Number, Date]
    },
    visibleYearsNumber: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    },
    noHeader: {
      type: Boolean,
      default: !1
    },
    noCalendarIcon: {
      type: Boolean,
      default: !1
    },
    fullscreenMobile: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    rtl: {
      type: Boolean,
      default: !1
    },
    origin: {
      type: String,
      default: void 0
    },
    allowOverflow: {
      type: Boolean,
      default: !0
    },
    attach: {
      validator: B,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1002
    }
  },
  data: function data() {
    return {
      date: void 0,
      isMenuActive: !1,
      isBooted: !1,
      activator: void 0
    };
  },
  computed: {
    classes: function classes() {
      return {
        "vd-wrapper--inline": this.inline,
        "vd-wrapper--disabled": this.disabled,
        "vd-wrapper--rtl": this.rtl
      };
    },
    componentId: function componentId() {
      return this.id || "datepicker_".concat("_".concat(Math.random().toString(36).substr(2, 9)));
    },
    inputFormat: function inputFormat() {
      return this.format ? this.format : function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "date";
        return m[t];
      }(this.range ? "range" : this.type);
    },
    headerFormat: function headerFormat() {
      return this.formatHeader ? this.formatHeader : function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "date";
        return y[t];
      }(this.range ? "range" : this.type);
    },
    outputFormat: function outputFormat() {
      return wt(this.range ? "range" : this.type);
    },
    textsFormat: function textsFormat() {
      var t = this.currentLocale.lang,
          e = t.buttonValidate,
          n = t.buttonCancel,
          r = t.rangeHeaderText;
      return {
        buttonValidate: this.buttonValidate || e,
        buttonCancel: this.buttonCancel || n,
        rangeHeaderText: this.rangeHeaderText || r
      };
    },
    internalDate: {
      get: function get() {
        return t = this.value, e = {
          range: this.range,
          locale: this.currentLocale,
          type: this.type
        }, n = e.range, r = e.locale, i = e.type, n ? {
          start: t && null != t.start ? Tt({
            date: t.start,
            locale: r
          }) : void 0,
          end: t && null != t.end ? Tt({
            date: t.end,
            locale: r
          }) : void 0
        } : null != t ? Tt({
          date: t,
          locale: r,
          type: i
        }) : void 0;
        var t, e, n, r, i;
      },
      set: function set(t) {
        this.date = t;
      }
    },
    isDateDefined: function isDateDefined() {
      var t = !this.range && this.internalDate,
          e = this.range && this.internalDate && this.internalDate.start && this.internalDate.end;
      return Boolean(t) || Boolean(e);
    },
    formattedInputDate: function formattedInputDate() {
      return function (t) {
        var e = t.inputFormat,
            n = t.internalDate,
            r = t.isDateDefined,
            i = t.locale,
            a = t.range,
            o = t.rangeInputText,
            s = t.type;

        if (r) {
          if (a && o) {
            var c = Ft({
              dates: n,
              locale: i,
              format: e
            }).split(" ~ "),
                l = vt(c, 2);
            return Yt({
              regexText: o,
              startDate: l[0],
              endDate: l[1]
            });
          }

          var u = n.month(),
              d = "quarter" === s ? St(u) : u;
          return Et({
            date: n.set("month", d),
            locale: i,
            format: e
          });
        }
      }({
        inputFormat: this.inputFormat,
        internalDate: this.internalDate,
        isDateDefined: this.isDateDefined,
        locale: this.currentLocale,
        range: this.range,
        rangeInputText: this.rangeInputText,
        type: this.type
      });
    },
    isFullScreenMode: function isFullScreenMode() {
      return this.fullscreenMobile && this.isMobile;
    }
  },
  watch: {
    visible: {
      handler: function handler(t) {
        this.isMenuActive = t;
      },
      immediate: !0
    },
    isFullScreenMode: function isFullScreenMode() {
      var t = this;
      this.isMenuActive && (this.hideDatePicker(), setTimeout(function () {
        t.showDatePicker();
      }, 200));
    }
  },
  created: function created() {
    var t,
        e,
        n,
        r,
        i = this;
    ["no-input"].forEach(function (t) {
      var e, n, r;
      i.$attrs.hasOwnProperty(t) && (n = (e = {
        original: t,
        vm: i
      }).original, r = e.vm, ge("[REMOVED] '".concat(n, "' has been removed. You can safely omit it."), r));
    }), this.$attrs.hasOwnProperty("fullscreen-breakpoint") && (e = (t = {
      original: "fullscreen-mobile",
      replacement: "mobile-breakpoint",
      vm: this
    }).original, n = t.replacement, r = t.vm, ge("[UPGRADE] '".concat(e, "' is deprecated, use '").concat(n, "' instead."), r));
  },
  mounted: function mounted() {
    this.activator = this.$refs.activator;
  },
  beforeDestroy: function beforeDestroy() {
    this.hideDatePicker(), this.$emit("onDestroy");
  },
  methods: {
    showDatePicker: function showDatePicker() {
      this.disabled || (this.isMenuActive = !0, this.$emit("onOpen"));
    },
    hideDatePicker: function hideDatePicker() {
      this.isMenuActive && (this.isMenuActive = !1, this.isBooted = !1, t(), this.$emit("onClose"));
    },
    changeDate: function changeDate(t) {
      this.internalDate = t, this.validate || this.validateDate();
    },
    validateDate: function validateDate() {
      var t, e;
      this.date ? (this.$emit("input", (t = this.date, e = this.outputFormat, this.range ? {
        start: t.start.format(e),
        end: t.end && t.end.format(e)
      } : t.format(e))), this.$emit("onChange"), this.hideDatePicker()) : this.hideDatePicker();
    },
    onKeyDown: function onKeyDown(t) {
      var e = t.keyCode;
      if (this.$refs.menu) return [w.esc, w.tab].includes(e) ? this.hideDatePicker(t) : void 0;
    },
    onClearDate: function onClearDate() {
      this.$emit("input", void 0), this.$emit("onChange");
    },
    genContent: function genContent() {
      return this.inline ? [this.genAgenda()] : [this.$scopedSlots.activator ? this.genActivator() : this.genCustomInput(), this.genMenuWithContent()];
    },
    genActivator: function genActivator() {
      return this.$createElement("div", {
        staticClass: "vd-activator",
        directives: [{
          name: "click-outside",
          value: {
            isActive: this.isMenuActive && !this.isFullScreenMode,
            handler: this.hideDatePicker
          }
        }],
        on: {
          click: this.showDatePicker,
          keydown: this.onKeyDown
        },
        ref: "activator"
      }, [this.$scopedSlots.activator({
        date: this.formattedInputDate
      })]);
    },
    genCustomInput: function genCustomInput() {
      return this.$createElement(lt, {
        props: {
          clearable: this.clearable,
          color: this.color,
          date: this.formattedInputDate,
          disabled: this.disabled,
          id: this.componentId,
          isDateDefined: this.isDateDefined,
          isMenuActive: this.isMenuActive,
          name: this.name,
          noCalendarIcon: this.noCalendarIcon,
          placeholder: this.placeholder,
          tabindex: this.tabindex
        },
        directives: [{
          name: "click-outside",
          value: {
            isActive: this.isMenuActive && !this.isFullScreenMode,
            handler: this.hideDatePicker
          }
        }],
        nativeOn: {
          click: this.showDatePicker
        },
        on: {
          keydown: this.onKeyDown,
          clearDate: this.onClearDate
        },
        ref: "activator"
      });
    },
    genMenuWithContent: function genMenuWithContent() {
      var t = this,
          e = this.isFullScreenMode,
          n = ke(ke({}, Oe), {}, {
        value: this.isMenuActive,
        origin: this.origin,
        allowOverflow: this.allowOverflow,
        attach: !e && this.attach,
        transition: e ? "slide-in-out-transition" : "scale-transition",
        bottomSheet: e
      }),
          r = this.activator;
      return this.$createElement(K, {
        attrs: {
          role: "menu"
        },
        props: ke(ke({}, n), {}, {
          activator: r
        }),
        on: {
          transitionEnd: function transitionEnd() {
            t.isBooted = !0;
          }
        },
        ref: "menu"
      }, [this.genAgenda()]);
    },
    genAgenda: function genAgenda() {
      return this.$createElement(ve, {
        props: {
          allowedDates: this.allowedDates,
          buttonCancel: this.textsFormat.buttonCancel,
          buttonValidate: this.textsFormat.buttonValidate,
          color: this.color,
          date: this.internalDate,
          fullscreen: this.isBooted && this.isMenuActive && this.isFullScreenMode,
          headerFormat: this.headerFormat,
          locale: this.currentLocale,
          maxDate: this.maxDate,
          minDate: this.minDate,
          name: this.name,
          noHeader: this.noHeader,
          range: this.range,
          rangeHeaderText: this.textsFormat.rangeHeaderText,
          rangePresets: this.rangePresets,
          rtl: this.rtl,
          type: this.type,
          validate: this.validate,
          value: this.isMenuActive,
          visibleYearsNumber: this.visibleYearsNumber
        },
        on: {
          selectDate: this.changeDate,
          validateDate: this.validateDate,
          close: this.hideDatePicker
        },
        directives: [{
          name: "click-outside",
          value: {
            isActive: this.isBooted && this.isMenuActive,
            handler: this.hideDatePicker
          }
        }],
        ref: "agenda"
      });
    }
  },
  render: function render(t) {
    return t("div", {
      staticClass: "vd-wrapper",
      class: this.classes
    }, this.genContent());
  }
}),
    we = Object.freeze({
  __proto__: null,
  VueDatePicker: Me
});
var Ye = {
  installed: !1,
  version: "0.2.11",
  install: function t(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

    if (!t.installed) {
      t.installed = !0, r !== e && console.error("Multiple instances of Vue detected.");
      var i = n.components || {},
          a = n.options || {};
      e.prototype.$vuedatepicker = a, r.prototype.$vuedatepicker = a, Object.entries(i).forEach(function (t) {
        var n = vt(t, 2),
            r = n[0],
            i = n[1];
        e.component(r, i);
      });
    }
  }
},
    Se = Ye.install;
Ye.install = function (t, e) {
  Se.call(Ye, t, {
    components: we,
    options: e
  });
}, "undefined" != typeof window && window.Vue && window.Vue.use(Ye);
export default Ye;
export { Me as VueDatePicker };